{
  "dateFormats": {
    "age": "{{ date, age }}",
    "dayNumberShortDay": "{{ date, dayNumberShortDay }}",
    "longMonth": "{{ date, longMonth }}",
    "monthYear": "{{ date, monthYear }}",
    "shortMonth": "{{ date, shortMonth }}",
    "shortMonthDay": "{{ date, shortMonthDay }}",
    "shortMonthDayYear": "{{ date, shortMonthDayYear }}",
    "time": "{{ date, time }}",
    "dayShortMonthDay": "{{ date, dayShortMonthDay }}",
    "dayShortMonthDayYear": "{{ date, dayShortMonthDayYear }}",
    "dayNumber": "{{ date, dayNumber }}",
    "dayShort": "{{ date, dayShort }}",
    "dateTime": "{{ date, dateTime }}"
  },
  "Failed to load data.": "No se pudo cargar datos.",
  "Failed to load users data.": "No se pudo cargar los datos de usuario.",
  "Event was created.": "Se creó el evento.",
  "Failed to create event.": "No se pudo crear el evento.",
  "Event was updated.": "Se actualizó el evento.",
  "Failed to edit event.": "No se pudo editar el evento.",
  "Create program": "Crear programa",
  "Edit program": "Editar programa",
  "Something went wrong, please try again later.": "Algo salió mal, por favor inténtalo de nuevo más tarde.",
  "Something went wrong, kudo cannot be edited.": "Algo salió mal, no se pudo editar el kudo.",
  "If you are experiencing issues when creating new content, please turn off autocorrect on your device in order to use": "Si tienes problemas al crear contenido nuevo, desactiva la autocorrección en tu dispositivo para usarlo.",
  "Cancel": "Cancelar",
  "Don't show me this warning anymore": "No me muestres más esta advertencia.",
  "Terms and Conditions": "Términos y condiciones",
  "Do you wish to discard changes?": "¿Deseas descartar los cambios?",
  "Terms title": "Titulo de los términos",
  "Terms description": "Descripción de los términos",
  "Privacy title": "Título de privacidad",
  "Privacy description": "Descripción de privacidad",
  "Privacy url": "URL de privacidad",
  "Image has to be (1920x3840)": "La imagen tiene que ser (1920x3840)",
  "Are you sure?": "¿Estás seguro?",
  "Name": "Nombre",
  "Type": "Tipo",
  "Date Modified": "Fecha de modificación",
  "Size": "Tamaño",
  "No files": "No hay archivos",
  "Delete": "Borrar",
  "Rename": "Cambiar Nombre",
  "by": "por",
  "Folder name": "Nombre de la carpeta",
  "Create Folder": "Crear carpeta",
  "No Results Found": "No se han encontrado resultados",
  "Giving": "Donación",
  "All": "Todos",
  "Apply": "Aplicar",
  "Giving finished": "Donación finalizada",
  "Link has been copied to clipboard": "El enlace ha sido copiado al portapapeles",
  "Goal": "Meta",
  "Raised": "Recaudada",
  "To Go": "Restante",
  "Close": "Cerrar",
  "Country": "País",
  "State": "Estado",
  "One time": "Una vez",
  "Monthly": "Mensualmente",
  "Quarterly": "Trimestralmente",
  "Annually": "Anualmente",
  "Card Details and Card Holder Details": "Detalles de la tarjeta y detalles del titular de la tarjeta",
  "Card Details": "Detalles de la tarjeta",
  "Card Holder Details": "Detalles del titular de la tarjeta",
  "First name": "Nombre",
  "Last name": "Apellido",
  "Email": "Correo electrónico",
  "Street": "Calle",
  "City": "Ciudad",
  "ZIP": "Código Postal (ZIP)",
  "If you would like to donate by check please mail to:<br /> BigHeart Philanthropy<br /> {{ street }} {{ apt }}, {{ city }}, {{ state }} {{ zip }}": "Si deseas donar con cheque, por favor envía un correo a:<br /> BigHeart Philanthropy<br /> {{ street }} {{ apt }}, {{ city }}, {{ state }} {{ zip }}",
  "If you would like to set up a recurring donation, please sign up on  <1>this link</1>.": "Si deseas configurar una donación recurrente, regístrate en <1>este enlace</1>.",
  "one time": "una vez",
  "monthly": "Mensualmente",
  "quarterly": "Trimestralmente",
  "annually": "Anualmente",
  "Share": "Compartir",
  "Your <1></1> donation<3></3>of <6></6> is a success!": "Tu <1></1> donación<3></3> de <6></6> es un éxito!",
  "Thank you for your generous gift and supporting our {{ name }} family": "Gracias por su generoso regalo y por apoyar a {{ name }}",
  "To cancel or change your recurring donation to the BigHeart Philanthropy, please email <2></2>": "Para cancelar tu donación recurrente a BigHeart Philanthropy, envíanos un correo electrónico a <2></2>",
  "Current password": "Contraseña actual",
  "New password": "Nueva contraseña",
  "Change Password": "Cambiar contraseña",
  "Password was successfully updated.": "La contraseña se actualizó correctamente.",
  "Amount": "Suma",
  "First Name": "Nombre",
  "Last Name": "Apellido",
  "E-mail": "Correo electrónico",
  "Submit": "Confirmar",
  "Edit": "Editar",
  "Reply": "Responder",
  "Report": "Reportar",
  "Attachments": "Adjuntos",
  "Comment...": "Comentar...",
  "See more comments": "Ver más comentarios",
  "You are about to delete this community. By deleting this community, you will also delete all of the community's associated content. Are you sure you want to delete this community?": "Estás a punto de eliminar esta comunidad. Al eliminar esta comunidad, también eliminarás todo el contenido asociado de la comunidad. ¿Estás seguro de que deseas eliminar esta comunidad?",
  "Are you sure you want to delete this community? If you continue, the community will be permanently deleted. No content related to the community can be recovered.": "¿Estás seguro de que deseas eliminar esta comunidad? Si continúas, la comunidad se eliminará permanentemente. No se puede recuperar todo el contenido relacionado con la comunidad.",
  "Name of the community": "Nombre de la comunidad",
  "Description": "Descripción",
  "Search User": "Buscar usuario",
  "Newsfeed": "Noticias",
  "Conferences and Events": "Eventos Virtuales",
  "Messaging": "Mensajes",
  "Program": "Programas",
  "Donations": "Donaciones",
  "Files": "Archivos",
  "Daily Digest (Evening)": "Resumen diario (tarde)",
  "Daily Digest (Morning)": "Resumen diario (mañana)",
  "Hero Image": "Imagen Superior",
  "Organization": "Organización",
  "Email Notifications": "Notificaciones por correo electrónico",
  "Push Notifications": "Notificaciones push",
  "Community Member Permissions": "Permisos para miembros de la comunidad",
  "Enable Posts, Comments and Replies": "Activar publicaciones, comentarios y respuestas",
  "Disable Posts, Comments and Replies": "Desactivar Publicaciones, Comentarios y Respuestas",
  "Privacy": "Privacidad",
  "Public": "Pública",
  "Private": "Privada",
  "Secret": "Secreta",
  "Default community always needs to be public.": "La comunidad predeterminada siempre debe ser pública.",
  "Default community always needs to be secret.": "La comunidad predeterminada siempre debe ser secreta.",
  "Update": "Actualizar",
  "Member": "Miembro",
  "Joined!": "Soy miembro!",
  "Start Exploring!": "Comienza Explorar!",
  "Join Now!": "Únete Ahora!",
  "Request sent": "Se envió la solicitud",
  "Requests to join communities are generally reviewed within <1>24 hours</1>. Feel free to continue browsing other communities that interest you.": "Las solicitudes para unirse a las comunidades generalmente se revisan dentro de las <1>24 horas</1>.No dude en seguir navegando por otras comunidades que le interesen ",
  "Request to Join": "Solicitud de Unirse",
  "Why do you want to join this community?": "¿Por qué quieres unirte a esta comunidad?",
  "Send": "Enviar",
  "Archive": "Archivo",
  "Duplicate": "Duplicar",
  "Free Program": "Programa Gratuito",
  "authorWeeks": "De {{name}} • {{weeks}} semanas",
  "Sponsored by": "Auspiciado por",
  "Learn more": "Aprender más",
  "Let us know why you want to join this community": "Cuéntanos por qué quieres unirte a esta comunidad",
  "registered": "Registrado",
  "Unsubscribe": "Cancelar la suscripción",
  "Subscribe": "Suscribirse",
  "Are you sure you want to duplicate this program?": "¿Estás seguro de que deseas duplicar este programa?",
  "Program successfully duplicated.": "Programa duplicado con éxito.",
  "Duplicate program": "Duplicar el programa",
  "Please choose date in the future": "Por favor, elige una fecha en el futuro",
  "Start date": "Fecha de inicio",
  "Duplicate with users": "Duplicar con los usuarios",
  "Duplicate without users": "Duplicar sin los usuarios",
  "Price must be higher than sponsors prices": "El precio debe ser superior al precio del patrocinador(es))",
  "Program name": "Nombre del programa",
  "Choose...": "Elegir...",
  "Author/Provider": "Autor/Proveedor",
  "Author/Provider Content": "Contenido del autor/proveedor",
  "Content": "Contenido",
  "Program description": "Descripción del programa",
  "Who should enroll": "Quién debe inscribirse",
  "Instructors": "Instructores",
  "Save as Draft": "Guardar como Borrador",
  "Category": "Categoría",
  "Logo": "Logotipo",
  "Starts": "Comienza",
  "Ends": "Termina",
  "Price": "Precio",
  "Free program": "Programa gratuito",
  "Modules": "Módulos",
  "Comment in Program": "Permitir comentarios",
  "Enable Comments": "Activar comentarios",
  "Disable Comments": "Desactivar comentarios",
  "A request for approval will be created. The change will not be immediate.": "Se creará una solicitud de aprobación. El cambio no será inmediato.",
  "Member is automatically enrolled": "El miembro se inscribe automáticamente",
  "Mandatory enrollment is automatically turned on because program is set as Featured for this WLA. To change this go to Admin Console.": "La inscripción obligatoria se activa automáticamente porque el programa está configurado como Destacado para esta WLA. Para cambiar esto, vaya a la Consola de administración.",
  "Go to Admin Console": "Ir a la consola de administración",
  "Expected outcomes": "Resultados esperados",
  "Featured participant": "Participante destacado",
  "Featured participant quote": "Cita del participante destacado",
  "Photo": "Foto",
  "Add featured participant": "Añadir participante destacado",
  "Sponsor name": "Nombre del patrocinador",
  "Sponsor": "Patrocinador",
  "Add sponsor": "Añadir patrocinador",
  "Module": "Módulo",
  "Module Description": "Descripción del módulo",
  "+ Add Module": "+ Añadir Módulo",
  "Back": "Volver",
  "Create New": "Crear Nuevo",
  "Search Organization": "Buscar organización",
  "Search Community": "Buscar Comunidad",
  "Invitations have been sent.": "Se han enviado invitaciones.",
  "Invite Organizations": "Invitar a organizaciones",
  "Invite Communities": "Invitar a Comunidades",
  "Posts": "Conversaciónes",
  "Events": "Eventos",
  "Polls": "Encuestas",
  "Activities": "Actividades",
  "Default": "Predeterminado",
  "Sort By": "Ordenar por",
  "Date created": "Fecha de creación",
  "Alphabetically": "Alfabéticamente",
  "Content type": "Tipo de contenido",
  "Filter by category": "Filtrar por categoría",
  "Select": "Elegir",
  "No content yet": "Aún no hay contenido",
  "Posted by": "Publicado por",
  "Hosted by": "Alojado por",
  "Posted": "Publicado",
  "Please select the module the post belongs to": "Por favor, selecciona el módulo al que pertenece la publicación",
  "Formik is not valid": "El formulario no es válido",
  "Continue reading": "Continuar leyendo",
  "What is on your mind": "¿Qué quieres decir?",
  "Count not process your request. Please try again later.": "No pudimos procesar tu solicitud. Inténtelo de nuevo más tarde.",
  "Today": "Hoy",
  "Yesterday": "Ayer",
  "Custom": "A medida",
  "Clear": "Borrar",
  "Please check your form": "Por favor, revisa tu formulario",
  "Do you wish to discard your Event?": "¿Deseas descartar tu Evento?",
  "Live": "En Vivo",
  "Join": "Únete Ahora",
  "Test": "Probar",
  "Excel": "Excel",
  "PDF": "PDF",
  "Make a Donation": "Hacer una Donación",
  "Finished": "Terminada",
  "Kudos to": "Kudos a",
  "votes": "votos",
  "Do you really want to delete this event and all its content?": "¿Seguro que deseas eliminar este evento y todo su contenido?",
  "Delete this Post/Comment?": "¿Eliminar este Publicación/Comentario?",
  "Report this Post/Event/Comment?": "¿Reportar este Publicación/Evento/Comentario?",
  "events": "eventos",
  "see all": "ver todo",
  "File cannot be downloaded, please try again later.": "El archivo no se puede descargar, inténtelo de nuevo más tarde.",
  "Downloading": "Descargando",
  "Something went wrong. Please, try again later.": "Algo salió mal. Por favor, inténtelo de nuevo más tarde.",
  "Enter Your E-mail": "Ingresa tu correo electrónico",
  "Request new Password": "Solicitar nueva contraseña",
  "Administrators": "Administradores",
  "Invite": "Invitar",
  "Please click X and scroll down and submit the form to reflect the changes in the \"\" section": "Haz clic en X y desplázate hacia abajo y envíe el formulario para reflejar los cambios en la \"\" sección",
  "You cannot remove the last user!": "¡No puedes eliminar el último usuario!",
  "You cannot remove yourself!": "¡No puedes quitarte!",
  "No": "No",
  "Post in...": "Publicar en...",
  "Search...": "Buscar...",
  "Hide": "Ocultar",
  "Show": "Mostrar",
  "KB": "KB",
  "more": "mas",
  "Conversations": "Conversaciones",
  "Communities": "Comunidades",
  "Organizations": "Organizaciones",
  "Programs": "Programas",
  "People": "Personas",
  "Joined": "Soy Miembro",
  "Not Joined": "No Soy Miembro",
  "No results found": "No se han encontrado resultados",
  "See all": "Ver todo",
  "Done": "Listo",
  "Choose member": "Elegir miembro",
  "Expressing Kudos to": "Expresando Kudos a",
  "Password": "Contraseña",
  "Incorrect username and password.": "Nombre de usuario y contraseña incorrectos.",
  "Could not log in at this time. Please, try again later.": "No se pudo iniciar sesión en este momento. Por favor, inténtelo de nuevo más tarde.",
  "Log In": "Iniciar Sesión",
  "Forgot password?": "¿Olvidaste tu contraseña?",
  "Message": "Mensaje",
  "About me": "Sobre mí",
  "Works at:": "Trabaja en:",
  "Joined Organizations": "Organizaciones a las que me he unido",
  "Joined Communities": "Comunidades a las que me he unido",
  "Call": "Llamar",
  "Change role": "Cambiar rol",
  "Remove": "Quitar",
  "Type a name...": "Escribe un nombre...",
  "No results": "No hay resultados",
  "Type a message...": "Escribe un mensaje...",
  "Search members...": "Buscar miembros...",
  "This is very beginning of your conversation": "Esto es el comienzo de tu conversación",
  "No conversations yet.": "Aún no hay conversaciones.",
  "No member found.": "Miembro no encontrado.",
  "Maximum size per attached file is": "Tamaño máximo por archivo adjunto es",
  "Please try it again.": "Por favor, inténtelo de nuevo.",
  "Enter New Password": "Introduce tu nueva contraseña",
  "Confirm New Password": "Confirmar Nueva Contraseña",
  "Provided password reset token is invalid.": "El token de restablecimiento de contraseña proporcionado no es válido.",
  "Updating...": "Actualizando...",
  "Badge Notifications": "Notificaciónes por insignia",
  "You are about to delete this organization. By deleting this organization, you will also delete all of the organization's associated communities. Are you sure you want to delete this organization?": "Estás a punto de eliminar esta organización. Al eliminar esta organización, también eliminarás todas las comunidades asociadas de la organización. ¿Estás seguro de que deseas eliminar esta organización?",
  "Are you sure you want to delete this organization? If you continue, all communities related to the organization will be permanently deleted. No content or communities related to the organization can be recovered.": "¿Estás seguro de que deseas eliminar esta organización? Si continúas, todas las comunidades relacionadas con la organización se eliminarán permanentemente. No se puede recuperar ningún contenido o comunidades relacionadas con la organización.",
  "The field is required in the following URL format: https://www.example.com": "El campo es obligatorio en el siguiente formato de URL: https://www.example.com",
  "This field must be at least 9.": "Este campo debe contener 9 dígitos.",
  "Organization URL": "URL de la organización",
  "EIN Number": "Número EIN",
  "Please select a state": "Por favor selecciona un estado",
  "Inverse Logo": "Logotipo inverso",
  "About": "Acerca de",
  "No communities": "No hay comunidades",
  "More filters": "Más filtros",
  "Filter by Organization and Community": "Filtrar por organización y comunidad",
  "Your Computer": "Tu Computadora",
  "Dropbox": "Dropbox",
  "Dropbox SDK failed to load": "Dropbox SDK no se pudo cargar",
  "Dropbox is not loaded": "Dropbox no está cargado",
  "Poll question": "Pregunta de la encuesta",
  "Choice": "Opción",
  "Add Poll": "Agregar Encuesta",
  "Remove poll": "Eliminar encuesta",
  "Express your Kudos...": "Expresar tu Kudos...",
  "Post": "Publicar",
  "Pin post": "Anclar la publicación",
  "Post pinned": "Publicación anclada",
  "What is on your mind, ": "¿Qué quieres decir?",
  "Search by user name or email...": "Buscar por nombre de usuario o correo electrónico...",
  "Network": "Red",
  "Other networks": "Otras redes",
  "The post has been successfully shared": "La publicación se ha compartido con éxito",
  "Sharing Post": "Compartiendo publicación",
  "Insert comment...": "Insertar comentario...",
  "Share on:": "Compartir en:",
  "email has already been taken.": "El correo electrónico ya ha sido tomado.",
  "Could not sign up at this time. Please, try again later.": "No se pudo registrar en este momento. Por favor, inténtelo de nuevo más tarde.",
  "Sign Up": "Suscribirse",
  "Sign up": "Suscribirse",
  "Hide Translation": "Ocultar Traducción",
  "See Translation": "Ver Traducción",
  "Undo": "Deshacer",
  "Members": "Miembros",
  "White label": "Producto Blanco",
  "Your Profile": "Tu Perfil",
  "Settings": "Configuración",
  "Help": "Ayuda",
  "Invite Friends": "Invitar Amigos",
  "Log out": "Cerrar Sesión",
  "Home": "Inicio",
  "Messages": "Mensajes",
  "Dashboard": "Tablero de Control",
  "Go Back": "Volver",
  "News": "Noticias",
  "Leave Community": "Salir de la Comunidad",
  "Are you sure you want to leave <strong>{{communityName}}</strong> community?": "¿Estás seguro de que deseas salir de la comunidad <strong>{{communityName}}</strong>?",
  "Failed to leave community.": "No se pudo salir de la comunidad.",
  "English": "Inglés",
  "Are you sure you want to report this program?": "¿Estás seguro de que deseas reportar de este programa?",
  "Are you sure you want to leave this program?": "¿Estás seguro de que deseas salir de este programa?",
  "Unsubscribe program": "Cancelar la suscripción del programa",
  "Are you sure you want to unsubscribe <strong>{{programName}}</strong> program?": "¿Estás seguro de que deseas cancelar la suscripción del programa <strong>{{programName}}</strong>?",
  "You've successfully left the program": "Has salido el programa con éxito",
  "You have joined the program.": "Te has unido al programa.",
  "Timeline/Newsfeed": "Contenido",
  "Edit Event": "Editar Evento",
  "Delete Event": "Borrar Evento",
  "Report Event": "Reportar Evento",
  "Finish": "Terminar",
  "Create": "Crear",
  "Title": "Título",
  "Search community": "Buscar en la comunidad",
  "Apt": "Apt",
  "From": "De",
  "To": "A",
  "Allow custom amount": "Permitir cantidad personalizada",
  "Successfully saved!": "¡Guardado con éxito!",
  "Something went wrong.": "Algo salió mal.",
  "member(s)": "miembro(s)",
  "No Communities": "No hay Comunidades",
  "Create New Community": "Crear Nueva Comunidad",
  "Community was successfully updated.": "La comunidad se actualizó con éxito.",
  "Community was successfully created.": "La comunidad se creó con éxito.",
  "Community successfully deleted.": "La comunidad se eliminó con éxito.",
  "Cannot delete this community right now, please try again later.": "No se puede eliminar esta comunidad en este momento, inténtelo de nuevo más tarde.",
  "It can take several minutes to delete large community. Please wait.": "La eliminación de una comunidad grande puede tardar varios minutos. Espera por favor",
  "Summary": "Resumen",
  "Report was successfully sent.": "El informe se envió con éxito.",
  "Send donation receipts": "Enviar recibos de donación",
  "Donors": "Donantes",
  "donors selected": "donantes seleccionados",
  "Pin Posts": "Anclar Publicaciones",
  "Upload Files": "Cargar archivos",
  "Email format is invalid. Correct format is name@domain.tld.": "El formato de correo electrónico no es válido. El formato correcto es nombre@dominio.tld.",
  "Search users...": "Buscar usuarios...",
  "Pending Requests": "Solicitudes pendientes",
  "See more requests": "Ver más solicitudes",
  "There are no more requests to be loaded": "No hay más solicitudes que cargar",
  "Successfully invited!": "Invitado con éxito!",
  "Type email address and press enter, space or comma - Or copy/paste from a spreadsheet!": "Escribe la dirección de correo electrónico y pulsa Intro, espacio o coma - ¡O copia/pega desde una hoja de cálculo!",
  "Inviting...": "Invitando...",
  "Currently there are no pending requests": "Actualmente no hay solicitudes pendientes",
  "Accept": "Aceptar",
  "Decline": "Rechazar",
  "requested to join": "solicitó unirse",
  "reason to join": "razón para unirse",
  "No organizations": "No hay organizaciones",
  "Create New Organization": "Crear Nueva Organización",
  "Unlink": "Romper Enlace",
  "BigMarker event is not ready yet. Try again later.": "El evento aún no está listo. Inténtalo de nuevo más tarde.",
  "BACK": "ATRÁS",
  "Started in": "Comenzó en",
  "Check donations": "Donaciones a través de cheque",
  "No Results": "No Hay Resultados",
  "group": "grupo",
  "Contact": "Contacto",
  "Join Community": "Unirse a la comunidad",
  "Folder Successfully Created.": "Carpeta fue creada correctamente.",
  "Cannot create folder.": "No se puede crear la carpeta.",
  "Upload Successful.": "La carga fue exitosa.",
  "Add File": "Agregar Archivo",
  "Next": "Próximo",
  "Browse Organizations": "Explorar organizaciones",
  "to Get Started": "para Empezar",
  "Upcoming": "Próximos",
  "Past": "Pasados",
  "+ Create": "+ Crear",
  "EVENTS": "EVENTOS",
  "These users": "Estos usuarios",
  "This user": "Este usuario",
  "are already on the app.": "ya están en la aplicación.",
  "is already on the app.": "ya está en la aplicación.",
  "Email addresses...": "Correos Electrónicos...",
  "Notification settings was successfully updated.": "La configuración de notificaciones se actualizó correctamente.",
  "Community Notification Settings": "Configuración de notificaciones de la comunidad",
  "No Description": "No hay una descripción",
  "Learn More": "Aprender Más",
  "By": "De",
  "Who should enroll in this program?": "¿Quién debe inscribirse en este programa?",
  "Featured Participants": "Participantes destacados",
  "Overview": "Resumen",
  "All Folders": "Todas las carpetas",
  "No programs": "No hay programas",
  "All programs": "Todos los programas",
  "My programs": "Mis programas",
  "Draft": "Borrador",
  "Published": "Publicado",
  "Archived": "Archivado",
  "Not joined yet.": "Aún no se ha unido.",
  "Date Enrolled": "Fecha de inscripción",
  "Date Invited": "Fecha de invitación",
  "Enroll Members": "Inscribir miembros",
  "+ Enroll Members": "+ Inscribir miembros",
  "Sort by:": "Ordenar por:",
  "Pending": "Pendiente(s)",
  "You are at the end of the list. There are no more users to be loaded.": "Estás al final de la lista. No hay más usuarios para cargar.",
  "All Objects": "Todos los objetos",
  "Add New Post": "Añadir Nueva Publicación",
  "+ Add New Post": "+ Añadir Nueva Publicación",
  "+ Add New Event": "+ Añadir Nuevo Evento",
  "End of program content.": "Fin del contenido del programa.",
  "Select some post": "Seleccionar una publicación",
  "My Programs": "Mis Programas",
  "Explore BigHeart Network Programs": "Explora los programas de la red BigHeart",
  "Explore the programs you are not a member of": "Explora los programas de los que no eres miembro",
  "Please select a program you want to go to": "Por favor, selecciona un programa al que deseas ir",
  "Explore more programs": "Explorar más programas",
  "What type of program are you looking for?": "¿Qué tipo de programa estás buscando?",
  "Select category to get started": "Selecciona una categoría para empezar",
  "No invitees found with these parameters.": "No se han encontrado invitados con estos parámetros.",
  "Are you sure you want to delete this event?": "¿Estás seguro de que deseas eliminar este evento?",
  "All Invitees": "Todos los Invitados",
  "Registered": "Registrado",
  "Admin/Host": "Administradores",
  "Event successfully deleted.": "Evento eliminado correctamente.",
  "Event was not deleted, please try again later.": "El evento no se eliminó, inténtelo de nuevo más tarde.",
  "It can take several seconds to delete an event. Please wait.": "La eliminación de un evento puede tardar varios segundos. Espera por favor.",
  "Filter:": "Filtro:",
  "PLAY RECORDING": "REPRODUCIR GRABACIÓN",
  "No recording available": "No hay grabación disponible",
  "Video is processing...": "El vídeo se está procesando...",
  "Not able to join this video conference": "No puede unirse a esta videoconferencia",
  "Dial-In Information": "Información de acceso telefónico",
  "Phone Number": "Número de teléfono",
  "Dial-in ID": "Identificación de acceso telefónico",
  "Dial-in Passcode": "Código de acceso telefónico",
  "Are you going?": "¿Te vas?",
  "Comments": "Comentarios",
  "Video recording": "Grabación de vídeo",
  "Your browser does not support the video tag.": "El navegador no admite la etiqueta de vídeo.",
  "Event Post Create": "Crear Publicación",
  "Results for": "Resultados para",
  "General inquiries": "Consultas generales",
  "Cancel Payment": "Cancelar Pago",
  "To cancel or change your recurring donation, please email us at:": "Para cancelar o cambiar tu donación recurrente, envíanos un correo electrónico a:",
  "SEND INVITATIONS": "ENVIAR INVITACIONES",
  "Invite to:": "Invitar a:",
  "Sign Up Using Email": "Regístrese por correo electrónico",
  "or using social login": "o usando el inicio de sesión social",
  "Already have an account?": "¿Ya tienes una cuenta?",
  "Log in": "Iniciar Sesión",
  "Find Organizations": "Buscar organizaciones",
  "No Organizations": " Sin organizaciones",
  "My Communities": "Mis Comunidades",
  "Explore BigHeart Network Communities": "Explora las comunidades de la red BigHeart",
  "Explore the communities you are not a member of": "Explora las comunidades de las que no eres miembro",
  "What type of nonprofit are you looking for?": "¿Qué tipo de organización sin fines de lucro estás buscando?",
  "Please select a community you want to go to": "Selecciona una comunidad a la que desees ir",
  "Explore more communities": "Explorar más comunidades",
  "New Password": "Nueva Contraseña",
  "Your Notifications": "Tus Notificaciones",
  "Organization was successfully created.": "La organización se creó correctamente.",
  "Create a Default Community": "Crear una Comunidad Predeterminada",
  "Name:": "Nombre:",
  "City:": "Ciudad:",
  "Address:": "Dirección:",
  "State:": "Estado:",
  "Organization was successfully updated.": "La organización se actualizó correctamente.",
  "Organization successfully deleted.": "Organización eliminada correctamente.",
  "Cannot delete this organization right now, please try again later.": "No se puede eliminar esta organización en este momento, inténtelo de nuevo más tarde.",
  "It can take several minutes to delete large organization. Please wait.": "La eliminación de una organización grande puede tardar varios minutos. Espera por favor.",
  "Join Now": "Únete ahora",
  "Join an organization": "Únete a una organización",
  "that interests you": "que te interese",
  "Personal Information": "Datos Personales",
  "Do you really want to leave this community?": "¿Realmente quieres salir de esta comunidad?",
  "Leave community": "Salir de la comunidad",
  "Notifications": "Notificaciones",
  "Translations": "Traducciones",
  "Translation settings was successfully updated.": "La configuración de traducción se ha actualizado correctamente.",
  "Please, select language": "Por favor, selecciona el idioma",
  "Enable Translations": "Activar traducciones",
  "Language": "Idioma",
  "Not allowed to see this": "No se permite ver esto",
  "This event has started already": "Este evento ya ha comenzado",
  "This video conference is already over": "Esta videoconferencia ya ha terminado",
  "No events": "No hay eventos",
  "ago": "hace",
  "You have no unread notifications.": "No tienes notificaciones no leídas.",
  "Mark all as read": "Marcar todo como leído.",
  "Notifications Settings": "Configuración de Notificaciones",
  "Video Conference": "Videoconferencia",
  "Up to 64 participants total": "Hasta 64 participantes en total",
  "Interactive mode: all can share camera and audio": "Modo interactivo: todos pueden compartir cámara y audio",
  "Up to 64 admins/presenters with 1000 participants total": "Hasta 64 administradores/presentadores con 1000 participantes en total",
  "Presentation mode: Attendees can view, hear, chat, etc.": "Modo de presentación: los asistentes pueden ver, escuchar, chatear, etc.",
  "Interactive mode for members of Medical Communities": "Modo interactivo para miembros de Comunidades Médicas",
  "Webinar/Webcast": "Seminario web/transmisión web",
  "Please provide at least one community": "Proporciona al menos una comunidad",
  "By e-mail": "Por email",
  "search...": "buscar...",
  "No matches.": "No se encontraron coincidencias.",
  "Failed to upload": "Error al cargar",
  "Please wait for image upload": "Espera a que la imagen se cargue",
  "Add Featured Participant": "Añadir participante destacado",
  "Please provide start date": "Proporciona la fecha de inicio",
  "Please provide end date": "Proporciona la fecha de finalización",
  "Add Module": "Añadir Módulo",
  "Add Outcome": "Añadir Resultado",
  "Add Sponsor": "Añadir Patrocinador",
  "No selected users.": "No hay usuarios seleccionados.",
  "Orange": "Naranja",
  "Blue": "Azul",
  "Green": "Verde",
  "Red": "Rojo",
  "Gray": "Gris",
  "Black": "Negro",
  "byEmail": "Por email {{number}}",
  "registeredUsers": "Registrados: {{number}}",
  "startTimeError": "La fecha y hora de inicio del programa deben establecerse en el futuro",
  "endTimeError": "La fecha y hora de finalización del programa deben establecerse al menos 60 minutos antes de la fecha y hora de inicio",
  "modulesError": "El módulo del programa no puede estar en blanco",
  "priceError": "El precio del programa debe ser mayor o igual que la suma de los precios patrocinados",
  "Program was created.": "Programa fue creado.",
  "Failed to create program.": "No se pudo crear el programa.",
  "Admin": "Administrador",
  "Author": "Autor",
  "Invite admins / hosts": "Invitar a los administradores",
  "Invite presenters": "Invitar a presentadores",
  "Invite attendees": "Invitar a asistentes",
  "Edit Webinar / Webcast": "Editar Seminario Web / Transmisión por Internet",
  "Edit Video Conference": "Editar videoconferencia",
  "Create Webinar / Webcast": "Crear seminario web/webcast",
  "Create Video Conference": "Crear videoconferencia",
  "Please select the module the event belongs to": "Selecciona el módulo al que pertenece el evento",
  "Event details": "Detalles del evento",
  "Starts on": "Comienza a",
  "For": "Para",
  "Select community to invite": "Seleccionar comunidad para invitar",
  "Select community": "Selecciona la comunidad",
  "Who do you want to invite?": "¿A quién quieres invitar?",
  "All community members": "Todos los miembros de la comunidad",
  "You will invite all community members.": "Invitarás a todos los miembros de la comunidad.",
  "Select community members": "Seleccionar miembros de la comunidad",
  "Only invited community members can join.": "Solo los miembros invitados pueden unirse.",
  "Attendees": "Asistentes",
  "Admins / Hosts": "Administradores",
  "Presenters": "Presentadores",
  "Additional details": "Detalles adicionales",
  "Event photo": "Foto del evento",
  "Slides": "Diapositivas",
  "hours": "horas",
  "hour": "hora",
  "minute": "minuto",
  "minutes": "minutos",
  "Action cancelled": "Acción cancelada",
  "Featured participant name": "Nombre del participante destacado",
  "Upload featured participant photo": "Subir foto del participante destacado",
  "Basic information": "Información básica",
  "Select organization": "Seleccionar organización",
  "Categories": "Categorías",
  "Select category": "Seleccionar categoría",
  "Author / Provider": "Autor / Proveedor",
  "Upload author logo": "Cargar logotipo del autor",
  "Author / Provider content": "Contenido del Autor/Proveedor",
  "Dates and price": "Fechas y precio",
  "Start date and time": "Fecha y hora de inicio",
  "End date and time": "Fecha y hora de finalización",
  "Who should enroll in and outcomes": "Quién debe inscribirse en este programa y los resultados del programa",
  "Instructors, administrators and featured participants": "Instructores, administradores y participantes destacados",
  "Invite administrators": "Invitar a administradores",
  "Add administrator": "Añadir administrador",
  "Invite instructors": "Invitar a instructores",
  "Add instructor": "Añadir instructor",
  "Allow comments": "Permitir comentarios",
  "Expected outcome": "Resultado esperado",
  "Sponsored price": "Precio patrocinado",
  "Special characters": "Caracteres especiales",
  "Characters": "Caracteres",
  "Poll was created.": "Se creó la encuesta.",
  "Failed to create poll.": "No se pudo crear la encuesta.",
  "Create Poll": "Crear Encuesta",
  "Delete poll": "Eliminar encuesta",
  "Create poll": "Crear encuesta",
  "Create kudo": "Crear kudo",
  "Please select the module the poll belongs to": "Selecciona el módulo al que pertenece la encuesta",
  "Select type": "Seleccionar tipo",
  "Multiple choice": "De opción multiple",
  "Option": "Opción",
  "Poll": "Encuesta",
  "You can’t Give Kudos now": "No puedes dar Kudos ahora",
  "pollVotes_one": "voto",
  "pollVotes_other": "votos",
  "Failed to add vote": "No se pudo añadir el voto",
  "Activity was created.": "Se ha creado la actividad.",
  "Failed to create activity.": "No se pudo crear la actividad.",
  "Add New Activity": "Añadir nueva actividad",
  "Activity was updated.": "Se actualizó la actividad.",
  "Failed to update activity.": "No se pudo actualizar la actividad.",
  "Edit Activity": "Editar actividad",
  "Please select the module the activity belongs to": "Selecciona el módulo al que pertenece la actividad",
  "Activity name": "Nombre de la actividad",
  "Activity Description": "Descripción de la actividad",
  "Please make your selection": "Selecciona alguna opción",
  "Please, select maximum 3 interests": "Por favor, selecciona un máximo de 3 intereses",
  "Please, select gender": "Por favor, selecciona género",
  "Education level": "Nivel de educación",
  "Please, select education level": "Por favor, selecciona un nivel de educación",
  "Apartment": "Apartamiento",
  "Profession": "Profesión",
  "Please, select profession": "Por favor, selecciona una profesión",
  "Company name/school": "Nombre de la empresa/escuela",
  "Biography": "Biografía",
  "Edit Poll": "Editar Encuesta",
  "Poll was updated.": "Se ha actualizado la encuesta.",
  "Failed to update poll.": "No se pudo actualizar la encuesta.",
  "Create content": "Crear contenido",
  "What type of content do you want to create?": "¿Qué tipo de contenido deseas crear?",
  "Create Post": "Crear Publicación",
  "Create Event": "Crear Evento",
  "Create Activity": "Crear Actividad",
  "Poll has ended": "Encuesta ha terminado",
  "End time was changed to 1 hour later according to start time": "La hora de finalización se cambió a 1 hora más tarde en comparación con la hora de inicio",
  "Poll not started yet": "La encuesta no comenzó",
  "You can’t create Poll now": "No puedes crear una encuesta ahora",
  "brandedCommunities": "Explorar Comunidades de {{brandedName}} ",
  "Your progress was recorded.": "Tu progreso fue registrado.",
  "Thank you for new recording!": "Gracias.",
  "Failed to record your progress.": "No se pudo registrar tu progreso.",
  "Do you wish to discard your Poll?": "¿Deseas descartar tu encuesta?",
  "Activity did not start": "La actividad no comenzó.",
  "Activity has ended": "La actividad ha terminado.",
  "Download report": "Descargar informe",
  "activityPeriod": "Podrá registrar su progreso el {{day}}.",
  "postedBy": "Publicado en {{ createdAt, shortMonthDayYear }} a las {{ createdAt, time }} por:",
  "publishedBy": "Publicado en {{ publishedAt, shortMonthDayYear }} a las {{ publishedAt, time }} por:",
  "Was this valuable?": "¿Era valioso?",
  "Your evaluation was recorded.": "Su evaluación fue registrada.",
  "Failed to record your evaluation.": "No se pudo registrar la evaluación.",
  "Create post...": "Crear publicación...",
  "notValidPhone": "{{phoneNumber}} no es un número de teléfono válido. El número debe comenzar con + y no debe contener espacios. Ejemplo: +12133734253",
  "Please select periodicity": "Por favor selecciona la frecuencia",
  "Daily": "Diario",
  "Weekly": "Semanal",
  "Monday": "Lunes",
  "Tuesday": "Martes",
  "Wednesday": "Miércoles",
  "Thursday": "Jueves",
  "Friday": "Viernes",
  "Saturday": "Sábado",
  "Sunday": "Domingo",
  "I agree with": "Acepta los",
  "and": "y",
  "Upload sponsor logo": "Cargar logotipo del patrocinador",
  "Spanish": "Español",
  "Number": "Número",
  "Text": "Texto",
  "or": "o",
  "Select language": "Selecciona el idioma",
  "Report was successfully downloaded.": "El informe se descargó correctamente.",
  "Failed to download report.": "No se pudo descargar el informe.",
  "You are not authorized to perform this action.": "No estás autorizado a realizar esta acción.",
  "Frequency": "Frecuencia",
  "Question": "Pregunta",
  "Please, select a community.": "Por favor, seleccione una comunidad.",
  "Ends on": "Termina",
  "This field is required.": "Este campo es obligatorio",
  "Do you wish to log out?": "¿Deseas cerrar la sesión?",
  "Profile has been successfully updated.": "Tu perfil se ha actualizado con éxito.",
  "Cannot update your profile right now, please try again later.": "No se puede actualizar tu perfil en este momento, por favor inténtelo de nuevo más tarde.",
  "Your account is locked for 30 minutes after 5 failed attempts to login.": "Su cuenta se ha bloqueado durante 30 minutos después de 5 intentos fallidos de iniciar sesión.",
  "Your password expired. Please set a new password.": "Tu contraseña ha caducado. Establezca una nueva contraseña.",
  "password was used previously.": "La contraseña se utilizó anteriormente.",
  "passwordError": "La contraseña debe contener un mínimo de 12 caracteres, un máximo de 72 caracteres, al menos una letra mayúscula, una letra minúscula, un número, un carácter especial y diferente a sus últimas 10 contraseñas",
  "passwordErrorUsed": "Su nueva contraseña debe ser diferente a sus últimas 10 contraseñas",
  "passwordErrorCurrentPasswordInvalid": "La contraseña actual no es válida",
  "Reminders": "Recordatorios",
  "Add new reminder": "Añadir nuevo recordatorio",
  "Add new time": "Añadir nueva hora",
  "Submit your values": "Envía tus valores",
  "Are you sure you want to submit your response?": "¿Está seguro de que desea enviar su respuesta?",
  "Time": "Hora",
  "activityNotAvailableToday": "Podrá registrar su progreso el {{day}} a las {{time}}.",
  "activityAvailableAtAnotherTime": "Podrá registrar su progreso más tarde hoy a las {{time}}.",
  "current_password is invalid": "La contraseña actual no es válida",
  "No reminders were created for this activity": "No se crearon recordatorios para esta actividad",
  "reset_password_token is invalid": "El token de contraseña de restablecimiento no es válido",
  "Do you wish to discard your Activity?": "¿Deseas descartar tu actividad?",
  "Your account is locked.": "Tu cuenta está bloqueada.",
  "Bookmarks": "Favoritos",
  "Comment": "Comentar",
  "Unbookmark": "Eliminar de favoritos",
  "Successfully unbookmarked": "Eliminado de favoritos con éxito",
  "Something went wrong. The item couldn't be unbookmarked.": "Algo salió mal. El elemento no pudo eliminarse de favoritos.",
  "view comment": "Ver comentario",
  "view post": "ver publicación",
  "view poll": "ver encuesta",
  "view event": "ver evento",
  "view activity": "ver actividad",
  "Withings Sync": "Withings Sincronización",
  "Link with my Withings Account": "Enlace con mi cuenta Withings",
  "Unlink my Withings Account": "Disvincular mi cuenta Withings",
  "Program module": "Módulo de programa",
  "Webinar / Webcast name": "Nombre del seminario web/webcast",
  "Video conference name": "Nombre de la video conferencia",
  "Invitations": "Invitaciones",
  "Poll details": "Detalles de la encuesta",
  "Poll content": "Contenido de la encuesta",
  "Add new question": "Añadir nueva pregunta",
  "Add option": "Añadir opción",
  "Label": "Etiqueta",
  "Answers": "Respuestas",
  "Answer...": "Respuesta...",
  "Do you wish to discard your Post?": "¿Deseas descartar tu Publicación?",
  "Post content": "Contenido de la publicación",
  "Post details": "Detalles de la publicación",
  "Post was created.": "Se creó la publicación.",
  "Failed to create post.": "No se pudo crear la publicación.",
  "Post was updated.": "Se actualizó la publicación.",
  "Failed to edit post.": "No se pudo editar la publicación.",
  "Single choice": "Una opción",
  "Continue": "Continuar",
  "Activity details": "Detalles de la actividad",
  "(e.g.: select which exercise you did and for how long)": "(por ejemplo: selecciona qué ejercicio has hecho y durante cuánto tiempo)",
  "Data will be transferred automatically from Withings": "Los datos se transferirán automáticamente desde Withings",
  "What?": "¿Qué?",
  "What is expected? (e.g.: personal feedback to the webinar)": "¿Qué se espera? (por ejemplo: comentarios personales al seminario web)",
  "What is expected? (e.g.: your blood sugar value)": "¿Qué se espera? (por ejemplo: tu valor de azúcar en la sangre)",
  "What is expected? (e.g.:select the activity you did today)": "¿Qué se espera? (por ejemplo: selecciona la actividad que hizo hoy)",
  "Unit": "Unidad",
  "List of options (divide items by commas)": "Lista de opciones (dividir elementos por comas)",
  "Define options... (e.g..: run, walk, bike, jogging)": "Definir opciones... (por ejemplo: correr, caminar, andar en bicicleta, trotar)",
  "List of units (divide items by commas)": "Lista de unidades (dividir elementos por comas)",
  "Define units... (e.g.: minutes, lbs, miles)": "Definir unidades... (por ejemplo: minutos, libras, millas)",
  "Finish & Publish": "Terminar y Publicar",
  "Numeric value": "Valor numérico",
  "Select type of activity": "Selecciona el tipo de actividad",
  "Describe the question or response.": "Describe la pregunta o respuesta.",
  "Type of response data": "Tipo de datos de respuesta",
  "Manual": "Manual",
  "Withings weight": "Peso Withings",
  "Withings duration": "Duración Withings",
  "Withings distance": "Distancia Withings",
  "White board": "Pizarrón blanco",
  "Attach file": "Adjuntar archivo",
  "Kudos": "Dar felicitaciones a",
  "BigHeart Inputs": "Entradas de BigHeart",
  "T4IT Inputs": "Aportes del T4IT",
  "Please select all that apply": "Por favor selecciona todo lo que aplique",
  "Please select one": "Por favor selecciona una",
  "Thank you for your feedback.": "Gracias por tus comentarios.",
  "Failed to send feedback.": "No se enviaron comentarios.",
  "Journal": "Diario",
  "Create note": "Crear nota",
  "Do you wish to discard your Note?": "¿Deseas descartar tu nota?",
  "Delete this journal entry?": "¿Eliminar esta entrada de diario?",
  "Please select option": "Selecciona una opción por favor",
  "Is this Visit for you?": "¿Esto es una visita para ti?",
  "Visitor information": "Información del visitante",
  "Do you wish to discard your changes?": "¿Deseas descartar tus cambios?",
  "Your donation was not successful": "Tu donación no tuvo éxito",
  "Validation failed: Start time must be in the future": "Error en la validación: la hora de inicio debe ser en el futuro",
  "Authored by": "Escrito por",
  "Enter program": "Entrar en el programa",
  "Search Member": "Buscar un miembro",
  "You are not currently enrolled in a program. Click “Explore” to browse programs.": "Actualmente no estás inscrito en un programa. Haz clic en ”Explorar” para examinar programas.",
  "Admins": "Administradores",
  "Your video conference has ended. Click on the button below to go back to the app.": "Tu videoconferencia ha terminado. Haz clic en el botón de abajo para volver a la aplicación.",
  "Back to app": "Volver a la aplicación",
  "Please synchronize the withings device with your mobile app today.": "Por favor, sincroniza el dispositivo Withings con tu aplicación móvil hoy.",
  "You currently don't have any bookmarked content": "Actualmente no tienes ningún contenido marcado",
  "invitationStatus": "{{ status }} {{ date, shortMonthDayYear }} a las {{ date, time }}",
  "fileSearchItemDate": "{{ date, shortMonthDayYear }}{{ fileName }}",
  "postSearchItemDate": "{{ date, shortMonthDayYear }} en {{ community }}",
  "Access token is expired or invalid.": "El token de acceso ha caducado o no es válido.",
  "User must be a member of a community with valid MOD invitation code": "El usuario debe ser miembro de una comunidad con un MOD código de invitación válido",
  "Password complexity insufficient": "La complejidad de la contraseña es insuficiente",
  "This account is no longer valid. Please sign up with a new account.": "Esta cuenta ya no es válida, regístrese con una nueva cuenta.",
  "donationMinimum": "El valor mínimo es US ${{min}}",
  "Admin console": "Consola de administración",
  "Pinned posts": "Publicaciones ancladas",
  "Modules with attached content can't be removed": "Los módulos con contenido adjunto no se pueden quitar",
  "multiFieldInviteError_one": "Esto usuario {{items}} ya está en la aplicación - por favor invítelos a través de la opción de usuario registrado anterior.",
  "multiFieldInviteError_other": "Estos usuarios {{items}} ya están en la aplicación - por favor invítelos a través de la opción de usuario registrado anterior.",
  "This community has no content.": "Esta comunidad no tiene contenido.",
  "Activity task has been filled in already": "La tarea de actividad ya ha sido completada",
  "Search user or content...": "Buscar usuario o contenido...",
  "Add another activity": "Añadir otra actividad",
  "Activity": "Actividad",
  "Send reset link": "Enviar enlace de reinicio",
  "Your password was successfully changed": "Tu contraseña fue cambiada correctamente",
  "Terms": "Términos",
  "Privacy Policy": "Política de Privacidad",
  "Back to Log in": "Volver al inicio de sesión",
  "resetRequestSuccess": "El enlace se envió correctamente a su correo electrónico. Por favor, abra el enlace que le enviamos y restablezca su contraseña.",
  "Remember me": "Recuérdame",
  "Submit activity": "Enviar actividad",
  "withingsInfoMessage": "Permita que el usuario registrado complete el formulario de pedido de Withings y BE asignará el AEN de los dispositivos de Withings. Los dispositivos Withings se pueden pedir automáticamente en el programa",
  "Imperial": "Imperial",
  "Metric": "Métrico",
  "shareEmailInfoMessage": "Debe tener un cliente de correo electrónico instalado en el dispositivo que admita esta función.",
  "Male": "Masculino",
  "Female": "Femenina",
  "Height": "Estatura",
  "Gender": "Género",
  "Date of birth": "Fecha de nacimiento",
  "Weight": "Peso",
  "Delivery information": "Información de entrega",
  "Telephone number": "Número de teléfono",
  "Address 1 (Street with number)": "Dirección 1 (Calle con número)",
  "Street with number": "Calle con número",
  "Address 2 (Apartment or suite number)": "Dirección 2 (El número de apartamento o Suite)",
  "Apartment or suite number": "El número de apartamento o Suite",
  "Zip code": "Código postal",
  "Device preset": "Ajuste preestablecido del dispositivo",
  "Personal information": "Datos personales",
  "Phone number": "Número de teléfono",
  "Address": "Dirección",
  "I agree to receive commercial and marketing emails from Withings": "Yo acepto recibir correos electrónicos comerciales y de marketing de Withings",
  "Subscribe with order": "Suscribirse con pedido",
  "Continue to program": "Continúe con el programa.",
  "Reset password": "Restablecer la contraseña",
  "The devices will be delivered to your delivery address within two weeks. In the next steps it is necessary to enter your personal data, confirm the delivery address. The devices will be customized for you.": "Los dispositivos se entregarán a su dirección de entrega en un plazo de dos semanas. En los siguientes pasos es necesario introducir sus datos personales y confirmar la dirección de entrega. Los dispositivos se personalizarán para usted.",
  "Order request": "Solicitud de pedido",
  "My language": "Mi idioma",
  "My timezone": "Mi zona horaria",
  "Order was successful!": "¡Su pedido fue exitoso!",
  "Copy invite to clipboard": "Copiar invitación al portapapeles",
  "Create Withings order": "Crear pedido Withings",
  "Do you wish to discard your Order?": "¿Desea descartar su pedido?",
  "Select module": "Seleccionar módulo",
  "Withings order": "Pedido Withings",
  "Create order": "Crear pedido",
  "Edit Order": "Editar pedido",
  "Edit Post": "Editar post",
  "Create Order": "Crear Pedido",
  "Withings order has been filled in already": "Su pedido de Withings ya se ha completado",
  "recurringPaymentInfo": "Se te cobrará cada {{interval}} a partir de hoy hasta que se cancele.",
  "cancelRecurringPaymentInfo": "Para cancelar o cambiar tu donación recurrente, ve a tu perfil.",
  "RPM program": "RPM programa",
  "DPP program": "DPP programa",
  "Move Activity Tracker Watch + Body Pro Scale": "Reloj con seguimiento de actividad Move + báscula Body Pro",
  "Price options": "Opciones de precio",
  "Paid": "Pagado",
  "Free": "Gratis",
  "Contact us": "Contactarnos",
  "Send Request": "Enviar petición",
  "Write your answer...": "Escribe tu respuesta...",
  "Why do you want to subscribe?": "¿Por qué quieres suscribirte?",
  "Request to Subscribe": "Solicitud de Suscripción",
  "requestToJoinFormTextAreaLabel": "Texto",
  "Withings calories": "Calorías de Withings ",
  "Withings steps": "Pasos de Withings",
  "Community cover image": "Imagen de portada de la comunidad",
  "membersCount_one": "{{count}} miembro",
  "membersCount_other": "{{count}} miembros",
  "Leave": "Abandonar",
  "Leave community?": "¿Salir de la comunidad?",
  "Do you want to leave selected community?": "¿Quieres salir de la comunidad seleccionada?",
  "Daily Digest (Evening time)": "Resumen diario (tiempo de la tarde)",
  "Daily Digest (Morning time)": "Resumen diario (hora de la mañana)",
  "Save": "Ahorrar",
  "Crop your image": "Recorta tu imagen",
  "Sorry, resource does not exist.": "Lo sentimos, el recurso no existe.",
  "Sorry, something went wrong.": "Perdón, algo salió mal.",
  "Sorry, you are not authorized to access this resource.": "Lo sentimos, no está autorizado para acceder a este recurso.",
  "Please check your internet connection.": "Por favor revise su conexion a internet.",
  "Failed": "Fallido",
  "Sending...": "Enviando...",
  "Retry": "Reintentar",
  "Save {{fileName}}": "Guardar {{fileName}}",
  "Sorry, you are not authorized to perform this action.": "Lo sentimos, no está autorizado para realizar esta acción.",
  "Sorry, resource or target does not exist.": "Lo sentimos, el recurso o el destino no existe.",
  "My profile": "Mi perfil",
  "Show more": "Mostrar más",
  "Failed to load Overall Points.": "No se pudieron cargar los puntos generales.",
  "Event name can't contain emojis": "El nombre del evento no puede contener emojis",
  "Height (in)": "Estatura (pulg)",
  "Height (ft)": "Estatura (pies)",
  "You are not permitted to access this data.": "No tienes permiso para acceder a estos datos.",
  "Please take your blood pressure.": "Por favor, tome su presión arterial.",
  "Please take your weight.": "Por favor, tome su peso.",
  "Report this Kudo/Comment?": "¿Reportar este Kudo/Comentario?",
  "Edit Cover Image": "Editar imagen de portada",
  "Click to upload image or drag image into this area": "Haga clic para cargar la imagen o arrastre la imagen a esta área",
  "Cover Image has to be {{width}}px width and {{height}}px height": "La imagen de portada debe tener {{width}}px de ancho y {{height}}px de alto",
  "{{fileName}} is not valid image": "{{fileName}} no es una imagen válida",
  "File": "Expediente",
  "Remove account": "Eliminar cuenta",
  "Sign out": "Desconectar",
  "Reason of your request": "Motivo de su solicitud",
  "Remove your account?": "¿Quitar tu cuenta?",
  "Failed to remove account": "No se pudo eliminar la cuenta",
  "Do you want to remove your account?": "¿Quieres eliminar tu cuenta?",
  "Account removal request was sent. You will now be logged out from your account.": "Se envió la solicitud de eliminación de la cuenta. Ahora serás desconectado de tu cuenta.",
  "Removing this account will delete all of its messages, contacts, and other data from the platform. This can’t be undone.": "Eliminar esta cuenta eliminará todos sus mensajes, contactos y otros datos de la plataforma. Esto no se puede deshacer.",
  "You will be logged out from your account immediately after this action.": "Se cerrará la sesión de su cuenta inmediatamente después de esta acción.",
  "Medical": "Médico",
  "Non-medical": "No medico",
  "No upcoming events": "Sin próximos eventos",
  "No past events": "Sin eventos pasados",
  "Organization type": "Tipo de organización",
  "Organization logo": "Logotipo de la organización",
  "Admin profile photo": "Foto de perfil de administrador",
  "Invite via phone number": "Invitar a través del número de teléfono",
  "Phone numbers": "Números de teléfono",
  "E-mail addresses": "Correos electrónicos",
  "Invite Non-registered Users": "Invitar a usuarios no registrados",
  "Invite Registered Members": "Invitar a miembros registrados",
  "Copy Invite Link": "Copiar enlace de invitación",
  "Invite Selected": "Invitar seleccionado",
  "Get shareable link to invite members": "Obtenga un enlace para compartir para invitar a miembros",
  "Please, invite some users.": "Por favor, invita a algunos usuarios.",
  "Failed to invite users.": "No se pudo invitar a los usuarios.",
  "Choose program": "Elegir programa",
  "Rejected": "Rechazado",
  "File name": "Nombre del archivo",
  "Modified": "Modificado",
  "Rename file": "Renombrar activo",
  "Asset name successfully changed": "El nombre del recurso se cambió correctamente",
  "Asset successfully deleted": "Activo eliminado con éxito",
  "Delete file": "Eliminar archivo",
  "Delete folder": "Eliminar carpeta",
  "File deleted successfully": "Archivo eliminado correctamente",
  "File renamed successfully": "Archivo renombrado correctamente",
  "Folder deleted successfully": "Carpeta eliminada correctamente",
  "Folder renamed successfully": "Carpeta renombrada correctamente",
  "Are you sure you want to delete <strong>{{name}}</strong>?": "¿Seguro que quieres eliminar <strong>{{name}}</strong>?",
  "Folder <strong>{{name}}</strong> might not be empty. Are you sure you want to delete it?": "La carpeta <strong>{{name}}</strong> puede no estar vacía. ¿Seguro que quieres eliminarla?",
  "Something went wrong. File couldn't be deleted.": "Algo salió mal. No se pudo eliminar el archivo.",
  "Something went wrong. File couldn't be renamed.": "Algo salió mal. No se pudo renombrar el archivo.",
  "Something went wrong. Folder couldn't be deleted.": "Algo salió mal. No se pudo eliminar la carpeta.",
  "Something went wrong. Folder couldn't be renamed.": "Algo salió mal. No se pudo renombrar la carpeta.",
  "All Files": "Todos los archivos",
  "Upload": "Subir",
  "assetUploadSuccess": "{{asset}} cargado con éxito",
  "assetUploadFail": "Error al cargar {{asset}}",
  "Edit Description": "Editar Descripción",
  "Check donation": "Donación de cheques",
  "Upcoming events": "Próximos Eventos",
  "No, I can't make it": "No, no puedo hacerlo",
  "Yes, I'm going": "Si estoy yendo",
  "Members ({{count}})": "Miembros ({{count}})",
  "Participants": "Los participantes",
  "eventLayoutDurationSameDate": "{{ dateFrom, shortMonthDayYear }} {{ dateFrom, time }} - {{ dateTo, time }}",
  "Program type": "Tipo de programa",
  "Successfully reported.": "Reportado con éxito.",
  "Small Business Development": "Desarrollo de pequeñas empresas",
  "Financial Literacy": "Educación financiera",
  "Health": "Salud",
  "Mentoring & Career Development": "Tutoría y desarrollo profesional",
  "Parenting & Children": "Crianza de los hijos e hijos",
  "Advocacy & Social Justice": "Abogacía y justicia social",
  "Clinical Trials": "Ensayos clínicos",
  "Inspirations": "Inspiraciones",
  "How to sign in": "Cómo iniciar sesión",
  "Updating your App": "Actualización de su aplicación",
  "BigHeart Quick Start": "Inicio rápido de BigHeart",
  "Troubleshooting": "Solución de problemas",
  "Various ways of signing in to our application.": "Diversas formas de iniciar sesión en nuestra aplicación.",
  "Check and Update your Android/iOS App.": "Verifique y actualice su aplicación Android/iOS.",
  "Features our app provides you.": "Funciones que nuestra aplicación le ofrece.",
  "How to make a Donation via Google Pay/Apple Pay/Credit/Debit Card.": "Cómo hacer una donación a través de Google Pay/Apple Pay/tarjeta de crédito/débito.",
  "FAQ about common issues.": "Preguntas frecuentes sobre problemas comunes.",
  "Art, Culture & Museums": "Arte, Cultura y Museos",
  "Education/Schools": "Educación/Escuelas",
  "Environmental": "Ambiental",
  "Food Pantries": "Despensas de alimentos",
  "Mental Health": "Salud mental",
  "Personal Development": "Desarrollo personal",
  "Shelters": "Refugios",
  "Sports": "Deportes",
  "Visit details": "Detalles de la visita",
  "Transportation": "Transporte",
  "Telehealth Visit": "Visita de telesalud",
  "Only for members of Medical Communities": "Solo para miembros de Comunidades Médicas",
  "If you are experiencing a medical emergency or life-threatening medical condition, do NOT continue to request a virtual visit.": "Si tiene una emergencia médica o una afección médica que pone en riesgo su vida, NO continúe solicitando una visita virtual.",
  "These symptoms include difficulty breathing or shortness of breath, chest pain or discomfort, dizziness, confusion, severe or persistent vomiting, and/or flu-like symptoms that improve then worsen again. Instead, immediately call 911 or go to your nearest emergency department.": "Estos síntomas incluyen dificultad para respirar o dificultad para respirar, dolor o malestar en el pecho, mareos, confusión, vómitos intensos o persistentes y/o síntomas similares a los de la gripe que mejoran y luego empeoran nuevamente. En su lugar, llame inmediatamente al 911 o vaya al departamento de emergencias más cercano.",
  "By clicking “Continue\" you are acknowledging that you are not experiencing a medical emergency and will continue to next step.": "Haciendo click “Continuar\" está reconociendo que no está experimentando una emergencia médica y continuará al siguiente paso.",
  "Fill out electronic form": "Rellenar formulario electrónico",
  "Call us on (773) 395-1830": "Llámanos (773) 395-1830",
  "Important notice": "Noticia importante",
  "E-mail me a log in link": "Enviarme un enlace de inicio de sesión por correo electrónico",
  "Log in link sent": "Enlace de inicio de sesión enviado",
  "We have sent you an email with a log in link. Go to your inbox, check your email, and click the button with the log in link. It will redirect you back to this app and automatically log you in.": "Le hemos enviado un correo electrónico con el enlace de inicio de sesión. Vaya a su bandeja de entrada, revise su correo electrónico y haga clic en el botón con el enlace de inicio de sesión. Lo redirigirá de regreso a esta aplicación e iniciará sesión automáticamente.",
  "Link expires in": "El enlace caduca en",
  "Back to log in page": "Volver a la página de inicio de sesión",
  "Log in link resent": "Enlace de inicio de sesión reenviado",
  "Log in link is invalid": "El enlace de inicio de sesión no es válido",
  "Log in link expired or was already used": "El enlace de inicio de sesión caducó o ya se usó",
  "Logging you in": "Iniciando sesión",
  "Quick Actions": "Acciones rápidas",
  "Request telehealth visit": "Solicitar visita de telesalud",
  "Request Telehealth Visit": "Solicitar Visita de Telesalud",
  "Choose community...": "Elige comunidad...",
  "Medical community": "Comunidad médica",
  "Choose type...": "Elegir tipo...",
  "Patient type": "Tipo de paciente",
  "Visit type": "Tipo de visita",
  "Visit type sub-option": "Subopción de tipo de visita",
  "Choose sub-option...": "Elija la subopción...",
  "Why do you need consultation": "¿Por qué necesita una consulta?",
  "Info: Tell us the reason for your visit and your preferred date, time, and duration of the appointment.": "Info: Cuéntanos el motivo de tu visita y tu fecha, hora y duración preferida para la cita.",
  "No community available for request.": "No hay comunidad disponible para solicitar.",
  "General Medical / Episodic Care sub-option": "Subopción de atención médica general / episódica",
  "Telehealth visit was requested": "Se solicitó visita de telesalud",
  "Select medical community": "Seleccionar comunidad médica",
  "Please select community": "Por favor seleccione comunidad",
  "sub-option": "subopción",
  "Please select": "Por favor seleccione",
  "Duration": "Duración",
  "Contact me at": "Contactame en",
  "Failed to request contact": "Error al solicitar contacto",
  "Duplicate Webinar / Webcast": "Webinar/Webcast duplicado",
  "Duplicate video conference": "Videoconferencia de seminario web duplicada",
  "Duplicate Event": "Evento duplicado",
  "Failed to duplicate event.": "No se pudo duplicar el evento.",
  "Event was duplicated.": "El evento fue duplicado.",
  "Contact request sent": "Solicitud de contacto enviada",
  "Middle name": "Segundo nombre",
  "Day": "Día",
  "Week": "Semana",
  "Month": "Mes",
  "Year": "Año",
  "more_communities_count_one": "y {{count}} otro.",
  "more_communities_count_other": "y {{count}} otros.",
  "Confirm consents to join": "Confirmar consentimientos para unirse",
  "Confirm consents": "Confirmar consentimientos",
  "Confirm Consents": "Confirmar Consentimientos",
  "Not now": "Ahora no",
  "You’re missing consents from following communities:": "Te faltan los consentimientos de las siguientes comunidades:",
  "To use the application, you must agree with policies. Without consent, it will not be possible to use the application.": "Para utilizar la aplicación, debe estar de acuerdo con las políticas. Sin consentimiento, no será posible utilizar la aplicación.",
  "Confirm": "Confirmar",
  "Failed to confirm consent: {{name}}": "No se pudo confirmar el consentimiento: {{name}}",
  "Confirmed": "Confirmado",
  "To join this community, you must agree with policies. Without consent, you cannot join the community.": "Para unirse a esta comunidad, debe aceptar las políticas. Sin consentimiento, no puede unirse a la comunidad.",
  "Copy link": "Copiar link",
  "Link copied successfully": "Enlace copiado correctamente",
  "Change Event": "Cambiar evento",
  "Event cannot be deleted during approval process": "El evento no se puede eliminar durante el proceso de aprobación",
  "Event cannot be changed during approval process": "El evento no se puede cambiar durante el proceso de aprobación",
  "Pending admin approval": "Pendiente de aprobación del administrador",
  "Event was declined by admin": "El evento fue rechazado por el administrador",
  "We cannot allow this event because the number of invited members is exceeded.": "No podemos permitir este evento porque se excede el número de miembros invitados.",
  "Event is past due": "El evento está vencido",
  "Admin did’t approve the event in time for the start of the event.": "El administrador no aprobó el evento a tiempo para el inicio del evento.",
  "Approved by admin": "Aprobado por el administrador",
  "The number of invitees cannot be increased, beyond the specified limit, in the published event.": "No se puede aumentar el número de invitados, más allá del límite especificado, en el evento publicado.",
  "This action is irreversible.": "Esta acción es irreversible.",
  "Withings heart rate": "Ritmo cardíaco de Withings",
  "Link for presenter copied to clipboard": "Enlace para el presentador copiado al portapapeles",
  "Link for Attendee copied to clipboard": "Enlace para asistente copiado al portapapeles",
  "Use password": "Utilizar contraseña",
  "Send email link": "Enviar enlace de correo electrónico",
  "All log in options": "Todas las opciones de inicio de sesión",
  "Use password to log in": "Usar contraseña para iniciar sesión",
  "Request new link": "Solicitar nuevo enlace",
  "Lowercase letter": "Letra minúscula",
  "At least 12 characters": "Al menos 12 caracteres",
  "Uppercase letter": "Letra mayúscula",
  "Symbol: @#$%^&* etc.": "Símbolo: @#$%^&* etc.",
  "Welcome to": "Bienvenido a ",
  "What’s next?": "¿Que sigue?",
  "Event cover image": "Imagen de portada del evento",
  "You're invited!": "¡Estás invitado!",
  "Please come back up to {{count}} minutes before the event starts": "Vuelve hasta {{count}} minutos antes de que comience el evento.",
  "This event has ended": "Este evento ha terminado",
  "Join Event": "Unirse al evento",
  "There was an error uploading the file": "Hubo un error al cargar el archivo",
  "Go to events": "Ir a eventos",
  "Providers": "Proveedores",
  "Patients / Guests": "Pacientes / Invitados",
  "Link for patient / guest copied to clipboard": "Enlace para paciente / invitado copiado al portapapeles",
  "reminderInfo": "Puedes configurar tus propios recordatorios (cuántos días / horas / minutos antes de que el usuario al final del día será notificado – por ejemplo: cuando establezca recordatorios para 4 horas antes del final del día, el usuario será notificado a las 8pm).",
  "User removed successfully": "Usuario eliminado con éxito",
  "Something went wrong. The user could’t be removed.": "Algo salió mal. No se pudo eliminar el usuario.",
  "User with pending invitation cannot be removed": "No se puede eliminar al usuario con invitación pendiente",
  "See All": "Ver todo",
  "You're a member": "Eres miembro",
  "You've joined the {{ name }} organization": "Te has unido a la organización {{ name }}",
  "There was an error sending request to join community": "Se produjo un error al enviar la solicitud para unirse a la comunidad.",
  "Yes, remove": "Sí, eliminar",
  "Profile": "Cuenta",
  "White Label": "Etiqueta blanca",
  "EHR Portal": "PE de Salud",
  "Redirecting to Admin console": "Redirigir a la consola de administración",
  "(e.g.: share your personal feedback to the webinar)": "(por ejemplo: comparte tus comentarios personales en el seminario web)",
  "Get extended feedback or response from the user": "Obtenga comentarios o respuestas extendidas del usuario",
  "Get numeric value from the user": "Obtener valor numérico del usuario",
  "(e.g.: record your blood sugar value)": "(por ejemplo: registre su valor de azúcar en sangre)",
  "Physical activity": "Actividad Física ",
  "Withings blood pressure": "Presión arterial de Withings",
  "Redirecting to EHR Portal": "Redirigir a historia clínica electrónica",
  "Remove user from?": "¿Eliminar a {{fullName}} de {{groupName}}?",
  "Last updated on": "Ultima actualización en {{lastUpdateTime, time}}",
  "Time left": "En {{timeLeft}}",
  "In progress time left": "{{timeLeft}}",
  "Go to your profile": "Ir a tu perfil",
  "Confirm timezone": "Confirmar zona horaria",
  "Confirm your timezone": "Confirma tu zona horaria",
  "Timezone": "Zona horaria",
  "You can change the timezone in your profile.": "Puedes cambiar la zona horaria en tu perfil.",
  "You can change it in Your Profile": "Puedes cambiarlo en Tu Cuenta",
  "Please confirm that you’re currently located in the timezone displayed below.": "Confirme que se encuentra actualmente en la zona horaria que se muestra a continuación.",
  "Well done on finishing your To-Dos for today": "¡Bien hecho por terminar tus tareas pendientes de hoy!",
  "Great job on completing your To-Dos for today": "¡Buen trabajo al completar tus tareas pendientes de hoy!",
  "Your To-Do adventure starts here!": "¡Tu aventura de tareas pendientes comienza aquí!",
  "There are unread messages waiting for your attention. See what’s happening there": "Hay <strong>{{unreadMessages}}</strong> mensajes no leídos esperando su atención. Mira lo que está pasando allí.",
  "There are new notifications waiting for your attention. See what’s happening there": "Hay <strong>{{newNotifications}}</strong> notificaciones nuevas esperando su atención. Mira lo que está pasando allí.",
  "Stay organized and accomplish tasks throughout the day. Explore more features as you complete your To-Dos or wait for new ones": "Manténgase organizado y realice tareas durante todo el día. Explore más funciones a medida que completa sus tareas pendientes o espera otras nuevas.",
  "If all To-Dos are completed, user has no To-Dos for that day, all messages are read, all notifications are read or user opens app for the first time and has no To-Dos yet": "Si se completan todas las tareas pendientes, el usuario no tiene tareas pendientes para ese día, se leen todos los mensajes, se leen todas las notificaciones o el usuario abre la aplicación por primera vez y aún no tiene tareas pendientes.",
  "Check my messages": "Revisa mis mensajes",
  "Open notifications": "Notificaciones abiertas",
  "See what’s happening": "Mira lo que está pasando",
  "Mark activity as completed": "Marcar actividad como completada",
  "Activity marked as completed": "Actividad marcada como completada",
  "You have no upcoming events": "No tienes eventos próximos",
  "You have no past events": "No tienes eventos pasados",
  "Add Users to General BigHeart Community": "Agregar usuarios a la comunidad general de BigHeart",
  "No, I'm not going": "No, no voy a ir",
  "There are no programs to explore yet": "Aún no hay programas para explorar",
  "Forgot password": "Has olvidado tu contraseña",
  "More communities": "Más comunidades",
  "morePills": "+{{ pillsNumber }} más",
  "Continue to billing information": "Continuar a información de facturación",
  "Continue to donation page": "Continuar a la página de donación",
  "Custom amount": "Cantidad personalizada",
  "Thank you for donation!": "¡Gracias por la donación!",
  "Select amount": "Seleccionar cantidad",
  "Fill billing information": "Complete la información de facturación",
  "Select donation type": "Seleccione tipo de donación",
  "There was a problem processing your payment": "Hubo un problema al procesar su pago",
  "Unknown user": "Usuario desconocido",
  "user": "usuario",
  "likesCount_zero": "Me gusta",
  "likesCount_one": "{{count}} Me gusta",
  "likesCount_other": "{{count}} Me gusta",
  "commentsCount_one": "{{count}} Comentario",
  "commentsCount_other": "{{count}} Comentarios",
  "Discover new public content curated by BigHeart. Browse through channels for programs and communities to find what interests you.": "Descubra nuevo contenido público curado por BigHeart. Explore los canales en busca de programas y comunidades para encontrar lo que le interesa.",
  "Channels": "Canales",
  "Sign in with Google": "Inicia sesión con Google",
  "MY": "MI",
  "View": "Ver",
  "You haven’t registered for any program yet": "Aún no te has registrado en ningún programa",
  "Discover new content that is right for you in our Channels": "Descubra contenido nuevo adecuado para usted en nuestros canales",
  "Featured": "Presentado",
  "Non-featured": "No destacado",
  "Program cover image": "Imagen de portada del programa",
  "This channel is empty": "Este canal está vacío.",
  "There is nothing available for this channel yet or you’ve joined all the content already": "Aún no hay nada disponible para este canal o ya te uniste a todo el contenido",
  "errorUserAlreadyInvited": "No se pudo invitar a los usuarios. Usuario/s ya invitados.",
  "Telehealth visit has been created already": "La visita de telesalud ya ha sido creada",
  "The event you're trying to create has already been created": "El evento que estás intentando crear ya ha sido creado.",
  "Request for Telehealth Visit denied": "Solicitud de visita de telesalud denegada",
  "The request you're trying to access has been denied already. Please go back to Admin Console and select Denied requests.": "La solicitud a la que intentas acceder ya ha sido denegada. Vuelva a la Consola de administración y seleccione Solicitudes denegadas.",
  "Request for Telehealth Visit expired": "La solicitud de visita de telesalud expiró",
  "The request you're trying to access has expired already": "La solicitud a la que estás intentando acceder ya ha caducado",
  "The password must contain following": "La contraseña debe contener lo siguiente",
  "StepCompleted": "Paso {{stepNumber}} - Completado",
  "StepWithNumber": "Paso {{stepNumber}}",
  "Source": "Fuente",
  "Push": "Empujar",
  "On": "En",
  "Off": "Apagado",
  "All notifications": "Todas las notificaciones",
  "Enable/disable all email notifications": "Activar/desactivar todas las notificaciones por correo electrónico",
  "Enable/disable all push notifications": "Activar/desactivar todas las notificaciones push",
  "email notifications settings for": "Configuración de notificaciones por correo electrónico para {{ value }}",
  "push notifications settings for": "Configuración de notificaciones push para {{value}}",
  "I understand": "Entiendo",
  "Good morning, {{name}}": "Buenos días, {{name}}",
  "Good afternoon, {{name}}": "Buenas tardes, {{name}}",
  "Good evening, {{name}}": "Buenas noches, {{name}}",
  "Error: E-mail is not valid. Please enter a valid email address (e.g., example@email.com)": "Error: el correo electrónico no es válido. Ingrese una dirección de correo electrónico válida (por ejemplo, ejemplo@email.com)",
  "Error: New password must be different from the current password.": "La nueva contraseña debe ser diferente de la contraseña actual.",
  "Error: ${label} cannot be a blank character": "Error: ${label} no puede ser un carácter en blanco",
  "Error: ${label} is not a valid number": "Error: ${label} no es un número válido",
  "Select tags": "Seleccionar etiquetas",
  "Error: Date and time cannot be in the past": "Error: la fecha y la hora no pueden ser anteriores",
  "Pin program as featured in Channels": "Programa de fijación como aparece en Canales",
  "Error: ${label} is required": "Error: se requiere ${label}",
  "Share on LinkedIn": "Compartir en LinkedIn",
  "It prevents program members from leaving the program after they are invited to the program. Automatically joins new community members of the invited communities to the program.": "Impide que los miembros del programa abandonen el programa después de haber sido invitados al programa. Une automáticamente a nuevos miembros de la comunidad de las comunidades invitadas al programa.",
  "Status": "Estado",
  "Share on Facebook": "Compartir en Facebook",
  "Repost": "Volver a publicar",
  "Link copied to clipboard": "Enlace copiado al portapapeles",
  "Share via email": "Compartir via correo electrónico",
  "There are no programs to display here": "No hay programas para mostrar aquí",
  "Please confirm you are using your legal name and the information below is correct by clicking the continue button below. After confirmation, any changes will be reflected in your profile.": "Confirme que está utilizando su nombre legal y que la información a continuación es correcta haciendo clic en el botón continuar a continuación. Después de la confirmación, cualquier cambio se reflejará en su perfil.",
  "Confirm your information": "Confirma tu información",
  "Go to channels": "Ir a canales",
  "Error: Phone number is required. Please enter a valid phone number (e.g., 201 555 0123)": "Error: se requiere el número de teléfono. Ingrese un número de teléfono válido (por ejemplo, 201 555 0123)",
  "Invite Members": "Invitar a los miembros",
  "Search": "Buscar",
  "There are no communities to display here": "No hay comunidades para mostrar aquí.",
  "Tags": "Etiquetas",
  "Show less": "Muestra menos",
  "Notifications disabled": "Notificaciones deshabilitadas",
  "Either notifications are disabled by default in this community, or your global notifications are turned off": "O las notificaciones están deshabilitadas de forma predeterminada en esta comunidad o sus notificaciones globales están desactivadas",
  "Choose interests (more options to choose from)": "Elija intereses (más opciones para elegir)",
  "Event was already rated": "El evento ya fue calificado",
  "Authentication failed": "Error de autenticación",
  "Failed to send reset link": "No se pudo enviar el enlace de reinicio",
  "Your account has been locked for 30 minutes after 5 failed attempts to login. After this period, your account will be available with current credentials.": "Su cuenta ha sido bloqueada durante 30 minutos después de 5 intentos fallidos de iniciar sesión. Después de este período, su cuenta estará disponible con las credenciales actuales.",
  "If you wish to unlock your account sooner, you need to reset your password.": "Si desea desbloquear su cuenta antes, debe restablecer su contraseña.",
  "There are no channels yet or you’ve joined all the content already": "Aún no hay canales o ya te uniste a todo el contenido",
  "No channels yet ": "Aún no hay canales",
  "Show event in Channels": "Mostrar evento en Canales",
  "Pin event as featured in Channels": "Fijar evento como aparece en Canales",
  "Event will display in your organization’s channels. Everyone in your organization will be able to join the event.": "El evento se mostrará en los canales de su organización. Todos los miembros de su organización podrán unirse al evento.",
  "Event will appear as featured in Channels.": "El evento aparecerá como se muestra en Canales.",
  "Visibility in channels": "Visibilidad en canales",
  "Event": "Evento",
  "Giving cover image": "Imagen de portada de la donación",
  "Community will display in your organization’s channels. Everyone in your organization will be able join this community.": "La comunidad se mostrará en los canales de su organización. Todos los miembros de su organización podrán unirse a esta comunidad.",
  "Community will appear as featured in the Channels": "La comunidad aparecerá como se muestra en los canales.",
  "Pin Community as featured in Channels": "Fijar comunidad como aparece en Canales",
  "Show community in Channels": "Mostrar comunidad en Canales",
  "Show program in Channels": "Mostrar programa en Canales",
  "Skip": "Saltar",
  "Rate the Event": "Califica el evento",
  "How useful was the event?": "¿Qué tan útil fue el evento?",
  "What would improve your event experience?": "¿Qué mejoraría la experiencia de tu evento?",
  "Rate the Audio Quality": "Califica la calidad del audio",
  "How would you rate the audio quality?": "¿Cómo calificarías la calidad del audio?",
  "What would improve your audio quality?": "¿Qué mejoraría tu calidad de audio?",
  "Rate the Video Quality": "Califica la calidad del vídeo",
  "How would you rate the video quality?": "¿Cómo calificarías la calidad del video?",
  "What would improve your video quality?": "¿Qué mejoraría la calidad de tu vídeo?",
  "Error: Please provide publish date": "Error: proporcione la fecha de publicación",
  "Error: Post publish date must be set after Program start time": "Error: la fecha de publicación debe establecerse después de la hora de inicio del programa",
  "Error: Post publish date must be set before Program end time": "Error: la fecha de publicación debe establecerse antes de la hora de finalización del programa",
  "Publish date": "Fecha de publicación",
  "Read post": "Leer publicación",
  "Optional": "Opcional",
  "Error: To-Do due date must be set after Program start time": "Error: la fecha de vencimiento de las tareas pendientes debe establecerse después de la hora de inicio del programa",
  "Error: To-Do due date must be set before Program end time": "Error: la fecha de vencimiento de las tareas pendientes debe establecerse antes de la hora de finalización del programa",
  "Error: Due to date must be set after the publish date": "Error: la fecha de vencimiento debe establecerse después de la fecha de publicación",
  "loginHelpText": "Si no recibió el enlace de inicio de sesión, inténtelo de nuevo o <1>regístrese.</1>",
  "Anyone in the BigHeart ecosystem can explore and join public communities.": "Cualquiera en el ecosistema BigHeart puede explorar y unirse a comunidades públicas.",
  "Members join a secret community by invitation only. It is not searchable on the platform.": "Los miembros se unen a una comunidad secreta únicamente mediante invitación. No se puede buscar en la plataforma.",
  "Anyone in the BigHeart ecosystem can explore and request to join private communities. The community admin approves or denies the request to join.": "Cualquier persona en el ecosistema BigHeart puede explorar y solicitar unirse a comunidades privadas. El administrador de la comunidad aprueba o rechaza la solicitud para unirse.",
  "No description available": "No hay descripción disponible",
  "Join video": "Unirse al vídeo",
  "Post marked as read successfully": "Publicación marcada como leída exitosamente",
  "Failed to mark post as read": "No se pudo marcar la publicación como leída",
  "Mark as read": "Marcar como leído",
  "Marked as read": "Marcado como leído",
  "The selected organization is using ": "La organización seleccionada está utilizando ",
  "The selected community is part of an organization that is using": "La comunidad seleccionada es parte de una organización que está utilizando",
  "custom": "costumbre",
  "default": "por defecto",
  "channels": "canales",
  "Got it": "Entiendo",
  "Select version": "Seleccionar versión",
  "Here's what's new! The latest release includes new features, improvements, and bug fixes to make your experience better than ever": "¡Aquí está lo nuevo! La última versión incluye nuevas funciones, mejoras y correcciones de errores para que su experiencia sea mejor que nunca.",
  "Like": "Me gusta",
  "Name of company/school": "Nombre de la empresa/escuela",
  "Error: You can choose only 3 interests": "Error: Puedes elegir solo 3 intereses",
  "We cannot allow images from unknown sources for security reasons. Please use the regular upload method to submit your images.": "No podemos permitir imágenes de fuentes desconocidas por razones de seguridad. Utilice el método de carga habitual para enviar sus imágenes.",
  "Inviting the entire communities or organizations can result in a large number of invitations being sent. Please review the selection carefully before submitting to avoid any errors.": "Invitar a comunidades u organizaciones enteras puede resultar en el envío de una gran cantidad de invitaciones. Revise la selección detenidamente antes de enviarla para evitar errores.",
  "This option is available only for super admins. If you need to set this program to Public, please contact a super admin for assistance.": "Esta opción está disponible solo para superadministradores. Si necesita configurar este programa como Público, comuníquese con un superadministrador para obtener ayuda.",
  "This option is available only for super admins. If you need to set this community to Public, please contact a super admin for assistance.": "Esta opción está disponible solo para superadministradores. Si necesita configurar esta comunidad como Pública, comuníquese con un superadministrador para obtener ayuda.",
  "No data": "Sin datos",
  "No tags available. The selected community is in an organization that has no tags defined.": "No hay etiquetas disponibles. La comunidad seleccionada está en una organización que no tiene etiquetas definidas.",
  "time_tag_at": "A las {{ date, time }}",
  "time_tag_by": "A las {{ date, time }}",
  "time_tag_live": "Vivo",
  "Respond to invitation": "Responder a la invitación",
  "Join event": "Unirse al evento",
  "Complete activity": "Actividad completa",
  "Complete poll": "Encuesta completa",
  "Order device": "Dispositivo de pedido",
  "No tags available": "No hay etiquetas disponibles",
  "No tags available. The selected organization has no tags defined.": "No hay etiquetas disponibles. La organización seleccionada no tiene etiquetas definidas.",
  "Or, continue in browser": "O continuar en el navegador",
  "Please continue to enter your custom amount in Stripe.": "Continúe ingresando su monto personalizado en Stripe.",
  "Requests are generally reviewed withing 24 hours": "Las solicitudes generalmente se revisan dentro de las 24 horas",
  "Full name": "Nombre completo",
  "Error: Accepting Terms & Conditions is required": "Error: es necesario aceptar los términos y condiciones",
  "Error: {{label}} is still in process of uploading": "Error: {{label}} todavía está en proceso de carga",
  "Hello {{firstName}}!": "¡Hola {{firstName}}!",
  "onboardingTourWelcomeSubtitle_one": "En el siguiente paso {{count}}, necesitamos tu ayuda para personalizar tu experiencia en nuestra plataforma.",
  "onboardingTourWelcomeSubtitle_other": "En los próximos {{count}} pasos, necesitamos tu ayuda para personalizar tu experiencia en nuestra plataforma.",
  "Get started": "Empezar",
  "Step {{current}} of {{total}}": "Paso {{current}} de {{total}}",
  "Make it yours!": "¡Haz lo tuyo!",
  "To continue, please read and agree to our standard consents.": "Para continuar, lea y acepte nuestros consentimientos estándar.",
  "Avatar": "Avatar",
  "Other details": "Otros detalles",
  "Interests": "Intereses",
  "Add photo": "Añadir foto",
  "Onboarding": "Inducción",
  "Express yourself with a profile picture! Your phone number, date of birth, and timezone are only shared with your organization’s administrators.": "¡Exprésate con una foto de perfil! Tu número de teléfono, fecha de nacimiento y zona horaria solo se comparten con los administradores de tu organización.",
  "Welcome {{firstName}}!": "¡Bienvenido {{firstName}}!",
  "Thank you for signing up! Now you're ready to enjoy the app.": "Gracias por registrarte! Ahora estás listo para disfrutar de la aplicación.",
  "Let’s go": "Vámonos",
  "Info": "Información",
  "Unsync": "Dessincronizar",
  "Sync": "Sincronizar",
  "Google": "Google",
  "Outlook": "Outlook",
  "Apple": "Apple",
  "Error: Consent for {{label}} is required": "Error: se requiere consentimiento para {{label}}",
  "Error during accessing file": "Error al acceder al archivo",
  "Error during file upload": "Error durante la carga del archivo",
  "Abort file upload": "Cancelar carga de archivo",
  "Going": "Ir",
  "Not going": "No ir",
  "By completing the following order, you will receive Health devices free of charge": "Al completar el siguiente pedido, recibirás dispositivos de salud gratis",
  "I agree to the": "Estoy de acuerdo con el",
  "Terms & Conditions": "Términos y condiciones",
  "Order completeness was successful": "La finalización del pedido fue exitosa",
  "You successfully finished the order form. You will receive an e-mail when we will ship the Withings devices to your delivery address.": "Finalizó exitosamente el formulario de pedido. Recibirá un correo electrónico cuando le enviemos los dispositivos Withings a su dirección de entrega.",
  "Something went wrong. The post could not be created.": "Algo salió mal. No se pudo crear la publicación.",
  "Failed to connect to Google account.": "No se pudo conectar a la cuenta de Google.",
  "Attachment ({{count}})": "Adjunto ({{count}})",
  "Write comment...": "Escribir comentario...",
  "Attachments ({{count}})": "Adjuntos ({{count}})",
  "Clear all": "Borrar todo",
  "The attachment upload is still in progress. You can submit the post after the upload is finished.": "La carga del archivo adjunto aún está en progreso. Puede enviar la publicación una vez finalizada la carga.",
  "Error: Post cannot be empty": "Error: la publicación no puede estar vacía",
  "Release notes": "Notas de la versión",
  "MY STUFF": "MIS COSAS",
  "Go to Communities": "Ir a Comunidades",
  "Go to Programs": "Ir a Programas",
  "Go to Videos": "Ir a Videos",
  "Complete now": "Completar ahora",
  "Uploaded item is not a File object": "El elemento cargado no es un objeto de archivo",
  "The conversation is about to begin": "La conversación está por comenzar.",
  "Be first to add a comment and start a discussion": "Sea el primero en agregar un comentario e iniciar una discusión",
  "Repost successful": "Repost exitoso",
  "Create post": "Crear publicación",
  "Select your organization": "Selecciona tu organización",
  "{{organizationName}} photo": "{{organizationName}} foto",
  "Save all": "Guardar todo",
  "Files cannot be downloaded, please try again later.": "No se pueden descargar los archivos, inténtelo de nuevo más tarde.",
  "Account doesn’t exist": "La cuenta no existe",
  "Account you are trying to log in to, doesn’t exist. Please proceed with Sign up and create your account first.": "La cuenta a la que intentas iniciar sesión no existe. Continúe con Registrarse y crear su cuenta primero.",
  "Bi-weekly": "Quincenal",
  "Add video": "Añadir vídeo",
  "Choose organization": "Elige organización",
  "Video added successfully": "Video añadido correctamente",
  "Something went wrong, video couldn’t be added": "Algo salió mal, no se pudo agregar el video",
  "Videos": "Vídeos",
  "Recorded at": "Grabado en",
  "File uploaded successfully": "Archivo cargado exitosamente",
  "There are no organizations to display here": "No hay organizaciones para mostrar aquí",
  "Organization cover image": "Imagen de portada de la organización",
  "Processing videos": "Procesando videos",
  "We’re processing your video files. This may take a short while.": "Estamos procesando tus archivos de video. Esto puede tardar un poco.",
  "Upload a short video to get members interested. Members can always play this video for free.": "Sube un video corto para que los miembros se interesen. Los miembros siempre pueden reproducir este video gratis.",
  "Upload the full-length video here. If you've decided to add a price for the video, members will have to pay before they can view this video.": "Sube el video completo aquí. Si ha decidido agregar un precio al video, los miembros deberán pagar antes de poder ver este video.",
  "Click or drag file to this area to upload": "Haga clic o arrastre el archivo a esta área para cargarlo",
  "Support for a single file only": "Compatibilidad con un solo archivo únicamente",
  "Details": "Detalles",
  "Members can join after admin’s approval": "Los miembros pueden unirse después de la aprobación del administrador",
  "Any member can join": "Cualquier miembro puede unirse",
  "Member must be invited to be able to join": "El miembro debe ser invitado para poder unirse",
  "No giving found": "No se encontraron donaciones",
  "Currently, there is no active giving to display.": "Actualmente, no hay donaciones activas para mostrar.",
  "Video (Draft)": "Vídeo (borrador)",
  "formattedMembersCount_one": "{{formattedCount}} miembro",
  "formattedMembersCount_other": "{{formattedCount}} miembros",
  "The selected organization is using <strong>{{channelType}}</strong> channels": "La organización seleccionada está usando canales <strong>{{channelType}}</strong>",
  "Error: Selected tags are not valid for current organization": "Error: las etiquetas seleccionadas no son válidas para la organización actual",
  "Members will see this image preview in Channels and My Content.": "Los miembros verán esta vista previa de la imagen en Canales y Mi contenido",
  "Show video in Channels": "Mostrar video en Canales",
  "Video will display in your organization’s channels.<br/>Everyone in your organization will be able access this video.": "El video se mostrará en los canales de su organización.<br/>Todos los miembros de su organización podrán acceder a este video.",
  "Pin video as featured in Channels": "Fijar el video como destacado en los Canales",
  "Video will appear as featured in the Channels": "El video aparecerá como destacado en los Canales",
  "Error: File has incorrect aspect ratio {{widthAspect}}:{{heightAspect}}": "Error: el archivo tiene una relación de aspecto incorrecta {{widthAspect}}:{{heightAspect}}",
  "Sort": "Ordenar",
  "Group cover photo": "Foto de portada de grupo",
  "Hierarchy": "Jerarquía",
  "Church": "Iglesia",
  "District": "Distrito",
  "Jurisdiction": "Jurisdicción",
  "Region": "Región",
  "Association": "Asociación",
  "Denomination": "Denominación",
  "Private Label App": "Aplicación de etiqueta privada",
  "State Convention": "Convención estatal",
  "Video successfully deleted.": "Vídeo eliminado correctamente.",
  "Failed to delete video": "No se pudo eliminar el vídeo",
  "Video successfully edited": "Vídeo editado correctamente",
  "Edit video": "Editar vídeo",
  "Join Organization": "Unirse a la organización",
  "Organization cover photo": "Foto de portada de la organización",
  "Video (Archived)": "Vídeo (archivado)",
  "Associations": "Asociaciones",
  "Denominations": "Denominaciones",
  "Private Label Apps": "Aplicaciones de etiqueta privada",
  "Districts": "Distritos",
  "Jurisdictions": "Jurisdicciones",
  "Regions": "Regiones",
  "State conventions": "Convenciones estatales",
  "No churches": "Ninguna iglesia",
  "There are no churches to display here": "No hay iglesias para mostrar aquí",
  "Are you sure you want to delete {{name}}?": "¿Estás seguro de que quieres eliminar {{name}}?",
  "Are you sure you want to report {{name}}?": "¿Estás seguro de que quieres reportar {{name}}?",
  "Churches": "Iglesias",
  "Group profile photo": "Foto de perfil de grupo",
  "Organization profile photo": "Foto de perfil de la organización",
  "Click the Google Play button below to download the app.": "Haz clic en el botón Google Play para descargar la aplicación.",
  "Click the Install button in the top banner to download the app from the App Store.": "Haz clic en el botón Instalar del banner superior para descargar la aplicación del App Store.",
  "Go to Calendar": "Ir a Calendario",
  "Go to Givings": "Ir a Donaciones",
  "No channels": "Sin canales",
  "There are no channels to display here": "No hay canales para mostrar aquí",
  "Giving Dashboard": "Panel de Donaciones",
  "Error: You must agree to the terms and conditions": "Error: Debe aceptar los términos y condiciones",
  "Value": "Valor",
  "Unsupported option: {{option}}": "Opción no compatible: {{option}}",
  "Event cover photo": "Foto de portada del evento",
  "Webinar": "Seminario web",
  "Are you sure you want ot remove your account?": "¿Seguro que quieres eliminar tu cuenta?",
  "Account removal requested": "Eliminación de cuenta solicitada",
  "date_by_time": "Para el {{date, shortMonthDay}} a las {{date, time}}",
  "date_time": "{{date, shortMonthDay}} a las {{date, time}}",
  "date_year_by_time": "Para el {{date, shortMonthDayYear}} a las {{date, time}}",
  "date_year_time": "{{date, shortMonthDayYear}} a las {{date, time}}",
  "Appearance": "Apariencia",
  "Visible": "Visible",
  "Object will be visible as featured in Channels": "El objeto será visible como destacado en los canales",
  "Object will be visible in Channels": "El objeto será visible en los canales",
  "dateFormatTimeRange": "{{dateFrom, time}} - {{dateTo, time}}",
  "dateFormatShortMonthDayRangeWithYear": "{{dateFrom, shortMonthDay}} - {{dateTo, shortMonthDayYear}}",
  "pending": "{{count}} pendiente",
  "Error: Select month": "Error: Seleccionar mes",
  "Error: Select day": "Error: Seleccionar día",
  "Error: Select year": "Error: Seleccionar año",
  "Error: Number of days in month is not valid": "Error: El número de días del mes no es válido",
  "Error: Date of birth is not valid": "Error: La fecha de nacimiento no es válida",
  "Error: The attachment upload is still in progress.": "Error: La carga del archivo adjunto sigue en curso.",
  "Error: ${label} cannot be longer than ${max} characters": "Error: ${label} no puede tener más de ${max} caracteres",
  "Error: Poll start time must be set after Program start time": "Error: La hora de inicio de la encuesta debe ser posterior a la hora de inicio del programa",
  "Error: Poll end time must be set before Program end time": "Error: La hora de finalización de la encuesta debe ser anterior a la hora de finalización del programa",
  "Error: Activity start time must be set after Program start time": "Error: La hora de inicio de la actividad debe ser posterior a la hora de inicio del programa",
  "Error: Activity end time must be set before Program end time": "Error: La hora de finalización de la actividad debe ser anterior a la hora de finalización del programa",
  "You didn’t respond": "No respondiste",
  "months_one": "Mes",
  "months_other": "Meses",
  "days_one": "Día",
  "days_other": "Días",
  "hours_one": "Hora",
  "hours_other": "Horas",
  "mins_one": "Min",
  "mins_other": "Min",
  "secs_one": "Seg",
  "secs_other": "Seg",
  "Event starts in": "El evento comienza en",
  "Giving offering": "Ofrenda",
  "Giving donation": "Donación",
  "Giving tithe": "Diezmo",
  "Giving crowdfunding": "Crowdfunding",
  "Donations {{participants}}": "Donaciones ({{participants}})",
  "This action is irreversible!": "¡Esta acción es irreversible!",
  "Something went wrong. The event couldn’t be deleted.": "Algo salió mal. El evento no se pudo eliminar.",
  "We will notify admins of your organization": "Notificaremos a los administradores de su organización.",
  "Event has been reported to admins of your organization.": "Se ha reportado el evento a los administradores de su organización.",
  "Something went wrong. The report couldn’t be sent.": "Algo salió mal. No se pudo enviar el reporte.",
  "Use the address in my profile for billing": "Usar la dirección de mi perfil para facturación",
  "Update information also in my profile": "Actualizar información también en mi perfil",
  "Preset amounts": "Importes preestablecidos",
  "Set custom amount": "Establecer importe personalizado",
  "Make my gift recurring": "Hacer que mi donación sea recurrente",
  "How often would you like to send this gift?": "¿Con qué frecuencia desea enviar este regalo?",
  "Testimonial": "Testimonio",
  "Display my name and photo with my gift": "Mostrar mi nombre y foto con mi donación",
  "Display my name with my gift": "Mostrar mi nombre con mi donación",
  "You will be charged only once": "Se le cobrará solo una vez",
  "Do not display my name and photo with my gift": "No mostrar mi nombre ni foto con mi donación",
  "Do not display my name with my gift": "No mostrar mi nombre con mi donación",
  "Continue to payment": "Continuar con el pago",
  "My giving options": "Mis opciones de donación",
  "We apologize for the inconvenience, but the Id of the selected price option was not found in our system due to a technical error.": "Disculpen las molestias, pero el ID de la opción de precio seleccionada no se encontró en nuestro sistema debido a un error técnico.",
  "It will be displayed here once it’s ready.": "Se mostrará aquí cuando esté listo.",
  "The video recording is being processed.": "La grabación de video se está procesando.",
  "We’re waiting for admin to approve": "Estamos esperando la aprobación del administrador.",
  "Declined by admin": "Rechazado por el administrador.",
  "Past due": "Atrasado.",
  "This event is allowed since the admin has approved exceeding the member limit.": "Este evento está permitido porque el administrador aprobó que se exceda el límite de miembros.",
  "Approved": "Aprobado.",
  "Dial-in": "Acceso telefónico.",
  "App Language": "Idioma de la aplicación.",
  "The selected language determines the application’s interface language": "El idioma seleccionado determina el idioma de la interfaz de la aplicación.",
  "The selected language will be used to translate posts, polls, and other content": "El idioma seleccionado se utilizará para traducir publicaciones, encuestas y otro contenido.",
  "All community members are invited and can join": "Todos los miembros de la comunidad están invitados y pueden unirse.",
  "Selected community members": "Miembros seleccionados de la comunidad.",
  "Only selected community members are invited and can join": "Solo los miembros seleccionados de la comunidad están invitados y pueden unirse.",
  "Community profile photo": "Foto de perfil de la comunidad.",
  "Program profile photo": "Foto de perfil del programa.",
  "Invitation link successfully copied to clipboard": "Enlace de invitación copiado correctamente al portapapeles.",
  "Invitations sent successfully": "Invitaciones enviadas correctamente",
  "Invitations sent successfully to non-members": "Invitaciones enviadas correctamente a los no miembros",
  "Thank you for your generosity": "Gracias por tu generosidad",
  "Congratulations! Your gift has been successfully processed.": "¡Felicidades! Tu donación ha sido procesada correctamente.",
  "We sincerely appreciate your support.": "Apreciamos sinceramente tu apoyo.",
  "Additionally, we would be immensely grateful if you could share your giving with your friends and family. Together, we can make a difference and spread the word about our cause.": "Además, estaríamos inmensamente agradecidos si pudieras compartir tu donación con tus amigos y familiares. Juntos podemos marcar la diferencia y difundir nuestra causa.",
  "We couldn’t process your gift. Please try again later.": "No pudimos procesar tu donación. Por favor, inténtalo de nuevo más tarde.",
  "Linkedin": "Linkedin",
  "Facebook": "Facebook",
  "Giving successful": "Donación exitosa",
  "Giving failed": "Donación fallida",
  "Thank you once again for your generosity and support!": "¡Gracias una vez más por tu generosidad y apoyo!",
  "Giving email share subject": "¡Únete a mí para apoyar esta significativa donación!",
  "Giving email share body": "Hola,\n\n Acabo de contribuir a una causa significativa, y me encantaría que la conocieras. ¡Cada donación marca la diferencia!\n\nDonación: {{givingName}}\nMás información y dona aquí: {{givingPublicUrl}}\n\nJuntos, podemos crear un impacto duradero. Si esta causa habla a tu corazón, te animo a unirte a mí en la donación.\n\nBendiciones",
  "The request will be sent to admin. After admin's approval, your account will be removed. In the meantime you will be logged out.": "La solicitud se enviará al administrador. Después de la aprobación del administrador, tu cuenta será eliminada. Mientras tanto, se cerrará tu sesión.",
  "{{fileName}} is not valid image.": "{{fileName}} no es una imagen válida.",
  "Value is uploading": "El valor se está cargando",
  "Give by check": "Donar por cheque",
  "Pledge my gift": "Prometer mi donación",
  "Give": "Donar",
  "My giving summary": "Resumen de mis donaciones",
  "Total amount": "Cantidad total",
  "Give now": "Donar ahora",
  "Browse": "Explorar",
  "Add amount": "Agregar cantidad",
  "Latest confirmed invitees": "Últimos invitados confirmados",
  "Type email address and press enter, space or comma - Or paste from a spreadsheet!": "Escribe la dirección de correo electrónico y presiona enter, espacio o coma - ¡O pega desde una hoja de cálculo!",
  "You must be logged in to enter this event": "Debes iniciar sesión para entrar a este evento",
  "Join live": "Unirse en vivo",
  "Please come back later.": "Por favor, vuelve más tarde.",
  "The event has ended": "El evento ha terminado",
  "Error: Some phone numbers are invalid. The number must start with area code + and must not contain any spaces. Example: +12133734253": "Error: Algunos números de teléfono son inválidos. El número debe comenzar con el código de área + y no debe contener espacios. Ejemplo: +12133734253",
  "Type phone numbers and press enter, space or comma - Or paste from a spreadsheet!": "Escribe los números de teléfono y presiona enter, espacio o coma - ¡O pega desde una hoja de cálculo!",
  "You can display the QR code for someone nearby, share it through messaging apps, or download it to your device for later use": "Puedes mostrar el código QR a alguien cercano, compartirlo a través de aplicaciones de mensajería o descargarlo en tu dispositivo para usarlo más tarde",
  "By scanning the QR code, the recipient can accept the invitation and join the platform seamlessly. The process is quick and straightforward.": "Al escanear el código QR, el destinatario puede aceptar la invitación y unirse a la plataforma sin problemas. El proceso es rápido y sencillo.",
  "Please select at least one giving option": "Necesitas agregar al menos un elemento para continuar",
  "You are a member of multiple organizations. Please select an organization to proceed with Give Now": "Eres miembro de múltiples organizaciones. Por favor, selecciona una organización para continuar con Donar ahora",
  "No giving": "Sin donaciones",
  "No giving for this organization": "No hay donaciones para esta organización",
  "It looks like there is no giving available in Give now at the moment. Please check back later or contact your organization’s admin for more information.": "Parece que no hay donaciones disponibles en Donar ahora en este momento. Por favor, vuelve más tarde o contacta al administrador de tu organización para más información.",
  "There is currently no giving available for this organization in Give Now.  Please check back later or contact your organization’s admin for more information.": "Actualmente no hay donaciones disponibles para esta organización en Donar ahora. Por favor, vuelve más tarde o contacta al administrador de tu organización para más información.",
  "(You)": "(Tú)",
  "Accepted ({{count}})": "Aceptados ({{count}})",
  "{{invitees}} accepted": "{{invitees}} aceptaron",
  "accepted": "{{count}} aceptado",
  "declined": "{{count}} rechazado",
  "Accepted": "Aceptado",
  "Declined": "Rechazado",
  "Patient / Guest": "Paciente / Invitado",
  "Provider": "Proveedor",
  "Attendee": "Asistente",
  "Admin / Host": "Administrador / Anfitrión",
  "Presenter": "Presentador",
  "Role": "Rol",
  "Invite users": "Invitar usuarios",
  "All invitees": "Todos los invitados",
  "Anonymous": "Anónimo",
  "Testimonial successfully edited": "Testimonio editado correctamente",
  "Testimonial successfully deleted": "Testimonio eliminado correctamente",
  "Are you sure you want to report this testimonial?": "¿Estás seguro de que quieres reportar este testimonio?",
  "Testimonial has been reported to admins of your organization.": "El testimonio ha sido reportado a los administradores de tu organización.",
  "Are you sure you want to delete this testimonial?": "¿Estás seguro de que quieres eliminar este testimonio?",
  "Testimonial successfully deleted.": "Testimonio eliminado correctamente.",
  "Something went wrong. The testimonial couldn’t be deleted.": "Algo salió mal. El testimonio no pudo ser eliminado.",
  "paymentAge": "Hace {{ date, age }}",
  "{{recurringOption}} donor since {{startDate}}": "Donante {{recurringOption}} desde {{startDate}}",
  "testimonialAge": "Hace {{ date, age }}",
  "comments_zero": "Comentarios",
  "comments_one": "Comentarios ({{count}})",
  "comments_other": "Comentarios ({{count}})",
  "Add comment": "Añadir comentario",
  "Top donors": "Principales donantes",
  "top": "principales",
  "recent": "recientes",
  "Recent donations": "Donaciones recientes",
  "Do you want to duplicate event with all invitees?": "¿Quieres duplicar el evento con todos los invitados?",
  "There will be no attendees for this event, once this event is duplicated": "No habrá asistentes a este evento una vez que se duplique.",
  "All current invitees will get invitations for this event": "Todos los invitados actuales recibirán invitaciones para este evento.",
  "Yes": "Sí",
  "Invitees": "Invitados",
  "View in admin console": "Ver en la consola de administración",
  "Hero image": "Imagen principal",
  "Redirecting to Stripe portal": "Redireccionando al portal de Stripe",
  "My Financial Transactions": "Mis transacciones financieras",
  "Something went wrong. Invitations couldn’t been sent.": "Algo salió mal. No se pudieron enviar las invitaciones.",
  "Change to admin": "Cambiar a administrador",
  "Change to attendee": "Cambiar a asistente",
  "Change to presenter": "Cambiar a presentador",
  "Change to provider": "Cambiar a proveedor",
  "Change to patient": "Cambiar a paciente",
  "Remove from event": "Eliminar del evento",
  "{{name}}’s role changed to {{role}}": "El rol de {{name}} cambió a {{role}}",
  "Something went wrong. {{name}}’s role couldn’t be changed.": "Algo salió mal. No se pudo cambiar el rol de {{name}}.",
  "Are you sure you want to remove {{name}} from this event?": "¿Seguro que desea eliminar a {{name}} de este evento?",
  "{{name}} removed from event successfully": "{{name}} se eliminó del evento correctamente.",
  "Something went wrong. {{name}} couldn’t be removed from event.": "Algo salió mal. No se pudo eliminar a {{name}} del evento.",
  "Invite friends": "Invitar amigos",
  "Fetch primary user failed": "Error al obtener usuario principal",
  "Fetch secondary user failed": "Error al obtener usuario secundario",
  "Failed to fetch both users": "No se pudieron obtener ambos usuarios",
  "Recurring": "Recurrente",
  "Periodicity": "Periodicidad",
  "Link for presenter copied successfully": "Enlace del presentador copiado correctamente",
  "Link for attendee copied successfully": "Enlace del asistente copiado correctamente",
  "Link for patient / guest copied successfully": "Enlace del paciente/invitado copiado correctamente",
  "Send message": "Enviar mensaje",
  "Profile completeness": "Perfil completo",
  "Languages": "Idiomas",
  "Change password": "Cambiar contraseña",
  "Age": "Edad",
  "Location": "Ubicación",
  "Company / School": "Empresa / Escuela",
  "under_18": "Menor de 18 años",
  "18_to_24": "De 18 a 24 años",
  "25_to_34": "De 25 a 34 años",
  "35_to_44": "De 35 a 44 años",
  "45_to_54": "De 45 a 54 años",
  "55_to_64": "De 55 a 64 años",
  "65_or_over": "65 o más",
  "Unknown": "Desconocido",
  "{{name}}s post": "Publicación de {{name}}",
  "{{name}}s event": "Evento de {{name}}",
  "Load previous comments ": "Cargar comentarios anteriores",
  "Read more": "Leer más",
  "Read less": "Leer menos",
  "Edit profile": "Editar perfil",
  "Member cover photo": "Foto de portada del miembro",
  "Home Address": "Domicilio",
  "Other Details": "Otros detalles",
  "Birthdate": "Fecha de nacimiento",
  "Uploaded image": "Imagen subida",
  "User profile photo": "Foto de perfil del usuario",
  "User cover photo": "Foto de portada del usuario",
  "My Profile": "Mi perfil",
  "Joined programs": "Programas a los que se unió",
  "Joined organizations": "Organizaciones a las que se unió",
  "Joined communities": "Comunidades a las que se unió",
  "Any announcements will show up here once they’re created": "Todos los anuncios aparecerán aquí una vez creados",
  "No announcements yet": "Aún no hay anuncios",
  "Create announcement": "Crear anuncio",
  "Are you sure you want to report this announcement?": "¿Estás seguro de que quieres reportar este anuncio?",
  "Are you sure you want to report this post?": "¿Estás seguro de que quieres reportar esta publicación?",
  "Request": "Solicitar",
  "listUserName": "{{name}} (Tú)",
  "userAvatarProfilePhoto": "{{name}} - foto de perfil",
  "User hasn’t filled any info yet": "El usuario aún no ha completado ninguna información",
  "Preview": "Previsualización",
  "at": "a las",
  "{{participants}} enrolled": "{{participants}} inscritos",
  "formattedDonorsCount_one": "{{formattedCount}} donante único",
  "formattedDonorsCount_other": "{{formattedCount}} donantes únicos",
  "{{invitees}} going": "{{invitees}} asistiendo",
  "webinar": "Webinar",
  "conference": "Videoconferencia",
  "telehealth_visit": "Visita de telemedicina",
  "To-Dos for": "To-Dos para",
  "Tomorrow": "Mañana",
  "Language updated successfully": "Idioma actualizado correctamente",
  "Write content...": "Escribir contenido...",
  "You can invite this user again at any time.": "Puedes volver a invitar a este usuario en cualquier momento.",
  "attendee": "asistente",
  "admin": "administrador",
  "presenter": "presentador",
  "patient": "paciente",
  "provider": "proveedor",
  "To-Dos for today": "Tareas pendientes para hoy ({{numberOfTodos}})",
  "Your {{content}} has been published": "Tu {{content}} ha sido publicado",
  "post": "publicación",
  "announcement": "anuncio",
  "Announcements": "Anuncios",
  "Successfully updated": "Actualizado correctamente",
  "No To-Dos for tomorrow": "No hay tareas pendientes para mañana",
  "Any to-dos assigned to you for tomorrow will appear here": "Cualquier tarea pendiente asignada para mañana aparecerá aquí",
  "You can only invite friends to public communities": "Solo puedes invitar a amigos a comunidades públicas",
  "QR code": "Código QR",
  "Member select": "Seleccionar miembros",
  "How would you like to invite your friends?": "¿Cómo te gustaría invitar a tus amigos?",
  "Invite via QR code": "Invitar mediante código QR",
  "Select members to invite": "Seleccionar miembros para invitar",
  "Invite via e-mail": "Invitar mediante correo electrónico",
  "Send invitations": "Enviar invitaciones",
  "There are no channels here yet": "Aún no hay canales aquí",
  "There are no channels here. Try scrolling through the tabs above to find BigHeart, where you can explore interesting content.": "Aquí no hay canales. Prueba a desplazarte por las pestañas de arriba para encontrar BigHeart, donde podrás explorar contenido interesante.",
  "No channels in this organization": "No hay canales en esta organización",
  "Or click the App Store button below to download the app.": "O haz clic en el botón App Store de abajo para descargar la aplicación.",
  "What&apos;s next?": "¿Qué sigue?",
  "Click the “Get” button above": "Haz clic en el botón “Obtener” de arriba",
  "Try adjusting your search or filters": "Intenta ajustar tu búsqueda o filtros",
  "No videos found": "No se encontraron videos",
  "Your videos will appear here": "Tus videos aparecerán aquí",
  "No videos yet": "No hay videos aún",
  "View in Admin Console": "Ver en la consola de administración",
  "You don’t have any upcoming events at the moment": "No tienes ningún evento próximo en este momento",
  "You don’t have any past events at the moment": "No tienes ningún evento pasado en este momento",
  "No events yet": "No hay eventos aún",
  "Share via QR code": "Compartir mediante código QR",
  "shareQrCodeEntityName": "{{entityName}} Compartir código QR",
  "Recording available": "Grabación disponible",
  "Make sure this is intentional.": "Asegúrese de que sea intencionado.",
  "You are inviting more than {{count}} invitees!": "¡Estás invitando a más de {{count}} invitados!",
  "This requires approval from the admin. During approval process, event cannot be changed.": "Esto requiere la aprobación del administrador. Durante el proceso de aprobación, el evento no se puede cambiar.",
  "This program event is in an object that has not been published yet.": "Este evento de programa está en un objeto que aún no ha sido publicado.",
  "Not published": "No publicado",
  "If you leave now, your progress will be discarded. You’ll need to go back to Admin Console to start the process again.": "Si abandona ahora, su progreso se descartará. Necesitará volver a la consola de administración para iniciar el proceso nuevamente.",
  "Leave Telehealth visit creation?": "¿Desea abandonar la creación de la visita de telemedicina?",
  "Admin didn’t approve the event in time.": "La administración no aprobó el evento a tiempo.",
  "Something went wrong. Password cannot be changed right now.": "Algo ha ido mal. La contraseña no se puede cambiar en este momento.",
  "Something went wrong. File {{fileName}} couldn't be uploaded.": "Algo salió mal. El archivo {{fileName}} no se pudo subir.",
  "Something went wrong. The attachment couldn't be deleted.": "Algo salió mal. No se pudo eliminar el archivo adjunto.",
  "Your password has expired": "Su contraseña ha caducado",
  "Social": "Social",
  "Telehealth": "Telesalud",
  "This event doesn’t have a description yet": "Este evento aún no tiene una descripción",
  "No Description Available": "No hay una descripción disponible",
  "Medical group": "Grupo médico",
  "This conference has ended.": "Esta conferencia ha finalizado.",
  "The event is not ready yet. Please try again later.": "El evento aún no está listo. Por favor, inténtelo de nuevo más tarde.",
  "Sorry, we couldn’t determine the status of this event. Please try again later.": "Lo sentimos, no pudimos determinar el estado de este evento. Por favor, inténtelo de nuevo más tarde.",
  "This event has been canceled by author": "Este evento ha sido cancelado por el autor",
  "Event canceled": "Evento cancelado",
  "Canceled:": "Cancelado:",
  "Change timezone": "Cambiar zona horaria",
  "W{{weekNumber}}": "S{{weekNumber}}",
  "Go to today's date": "Ir a la fecha de hoy,<br/>{{date}}",
  "Go to current month": "Ir al mes actual,<br/>{{date}}",
  "Go to current week": "Ir a la semana actual,<br/>{{date}}",
  "Go to previous week": "Ir a la semana anterior,<br/>{{date}}",
  "Go to following week": "Ir a la semana siguiente,<br/>{{date}}",
  "Go to previous day": "Ir al día anterior,<br/>{{date}}",
  "Go to following day": "Ir al día siguiente,<br/>{{date}}",
  "Go to previous month": "Ir al mes anterior,<br/>{{date}}",
  "Go to following month": "Ir al mes siguiente,<br/>{{date}}",
  "There are currently no events for selected period": "No hay eventos para el período seleccionado",
  "Showing all invitations": "Mostrando todas las invitaciones",
  "Showing all upcoming declined invitations": "Mostrando todas las invitaciones rechazadas",
  "All your invitations to upcoming events will appear here": "Todas tus invitaciones a eventos próximos aparecerán aquí",
  "No upcoming invitations": "No hay invitaciones próximas",
  "Are you sure you want to report this kudo?": "¿Está seguro de que desea informar de este kudo?",
  "Kudos to...": "Felicitaciones a...",
  "No repeat": "No repetir",
  "Repeats daily": "Repite diariamente",
  "Repeats weekly": "Repite semanalmente",
  "Repeats monthly": "Repite mensualmente",
  "Online": "En línea",
  "going": "asistiendo",
  "No declined events": "No hay eventos rechazados",
  "If you decline an event, it will appear here": "Si rechazas un evento, aparecerá aquí",
  "Upcoming declined events": "Eventos rechazados próximos",
  "Past declined events": "Eventos rechazados pasados",
  "Upcoming Invitations": "Invitaciones próximas",
  "Declined events": "Eventos rechazados",
  "Are you sure you want to report this kudo": "¿Está seguro de que desea informar de este kudo?",
  "Are you sure you want to delete this kudo?": "¿Seguro que quieres borrar este kudo?",
  "Unable to load user details.": "No se pudieron cargar los detalles del usuario.",
  "You cannot decline an event where you are the author": "No puedes rechazar un evento donde eres el autor",
  "Passkeys": "Claves de acceso",
  "Create a passkey": "Crear una clave de acceso",
  "Something went wrong. The passkey couldn't be deleted.": "Algo salió mal. No se pudo eliminar la clave de acceso.",
  "Something went wrong. The passkey couldn't be created.": "Algo salió mal. No se pudo crear la clave de acceso.",
  "Passkey deleted successfully.": "La clave de acceso se ha eliminado correctamente.",
  "Passkey created successfully.": "Clave de acceso creada correctamente.",
  "With passkeys on BigHeart, you can securely sign in using your fingerprint, face, screen lock, or security key—no password needed. Passkeys and security keys can also serve as an extra verification step when logging in with a password. Keep your screen locks private and security keys safe so only you can access your BigHeart account": "Con las claves de acceso de BigHeart, puedes iniciar sesión de forma segura utilizando tu huella dactilar, tu rostro, el patrón de bloqueo de pantalla o una llave de seguridad, sin necesidad de contraseña. Las claves de acceso y las llaves de seguridad también pueden servir como un paso de verificación adicional al iniciar sesión con una contraseña. Mantén en secreto tus patrones de bloqueo de pantalla y guarda bien tus llaves de seguridad para que solo tú puedas acceder a tu cuenta de BigHeart.",
  "Delete the passkey?": "Eliminar la clave de acceso?",
  "Deleting this passkey means you’ll need to login differently next time.": "Si eliminas esta clave de acceso, la próxima vez tendrás que iniciar sesión de otra manera",
  "Send me the password": "Envíame la contraseña",
  "Log in and set up a passkey": "Inicia sesión y configura una clave de acceso",
  "Log in with passkey": "Iniciar sesión con clave de acceso",
  "Log in with Your Passkey": "Inicia sesión con tu clave de acceso",
  "If you can’t use a passkey, you can get a one‑time password sent to your email instead.": "Si no puedes utilizar una clave de acceso, puedes solicitar que te envíen una contraseña de un solo uso a tu correo electrónico.",
  "Use a passkey to log in with biometric authentication or your device&apos;s security. Passkeys are faster and more secure than passwords—and will be required soon.": "Utiliza una clave de acceso para iniciar sesión mediante autenticación biométrica o la función de seguridad de tu dispositivo. Las claves de acceso son más rápidas y seguras que las contraseñas, y pronto serán obligatorias.",
  "You&apos;ll sign in with a one-time password sent to your email. After you&apos;re logged in, you can create a passkey so next time you can log in with biometric authentication or your device&apos;s screen lock.": "Iniciarás sesión con una contraseña de un solo uso enviada a tu correo electrónico. Cuando hayas iniciado sesión, podrás crear una clave de acceso para que la próxima vez puedas iniciar sesión con autenticación biométrica o el bloqueo de pantalla de tu dispositivo.",
  "Passkeys are faster and more secure than passwords and protect you against phishing and other common attacks.": "Las claves de acceso son más rápidas y seguras que las contraseñas y te protegen contra el phishing y otros ataques habituales.",
  "You can set up a passkey anytime in Account → Settings → Passkeys.": "Puedes configurar una clave de acceso en cualquier momento en Cuenta → Ajustes → Claves de acceso.",
  "Send me the emial instead": "Envíame el correo electrónico",
  "Authentication with passkey failed. Try again later.": "Ha fallado la autenticación con la clave de acceso. Inténtalo de nuevo más tarde.",
  "There are currently no events for today": "No hay eventos para hoy",
  "Publish": "Publicar",
  "Mobile": "Móvil",
  "Download": "Descargar",
  "New": "Nuevo",
  "Updated": "Actualizado",
  "You canceled the passkey creation process": "Has cancelado el proceso de creación de la clave de acceso",
  "Passkey creation is not available on this device": "La creación de claves de acceso no está disponible en este dispositivo",
  "The passkey you're trying to create is already in use on this device": "La contraseña que estás intentando crear ya está en uso en este dispositivo",
  "Passkey creation failed for an unknown reason": "La creación de la clave de acceso ha fallado por motivos desconocidos",
  "We are sad to see you go!": "¡Nos da mucha pena que te vayas!",
  "You have successfully unsubscribed, you will no longer receive this type of emails.": "Te has dado de baja correctamente y ya no recibirás este tipo de correos electrónicos.",
  "Step {{step}} of {{total}}": "Paso {{step}} de {{total}}",
  "No medical group found": "No se encontró ningún grupo médico",
  "Failed to load medical group details. The telehealth visit request could not be created. Please try again later.": "No se pudieron cargar los detalles del grupo médico. La solicitud de visita de telemedicina no pudo ser creada. Por favor, inténtalo de nuevo más tarde.",
  "Calendar": "Calendario",
  "min": "min",
  "hr_one": "{{count}} hr",
  "hr_other": "{{count}} hrs",
  "Times are shown in your browser's timezone ({{timeZone}}, {{offset}})": "Los horarios se muestran en la zona horaria de tu navegador ({{timeZone}}, {{offset}})",
  "Event over midnight: Event ends on {{date}} at {{time}} with duration of {{duration}}.": "<strong>Evento pasada la medianoche:</strong> El evento termina el {{date}} a las {{time}} con una duración de {{duration}}.",
  "Attach files": "Adjuntar archivos",
  "Event will appear in Channels and become public. Anyone will be able to join.": "El evento aparecerá en los canales y se hará público. Cualquier persona podrá unirse.",
  "Show event in Channels (Optional)": "Mostrar evento en canales (opcional)",
  "Error: Date must be in the future": "Error: La fecha debe ser en el futuro",
  "Error: Starts is not a valid time": "Error: La hora de inicio no es válida",
  "Error: Starts must be in the future": "Error: La hora de inicio debe ser en el futuro",
  "Choose organization...": "Elegir organización...",
  "Event created successfully.": "Evento creado correctamente.",
  "Support for a single or bulk upload.": "Soporte para un solo o carga masiva.",
  "Media cannot be uploaded, please try again later.": "El medio no se puede subir, por favor inténtalo de nuevo más tarde.",
  "Event attachments cannot be uploaded, please try again later.": "Los archivos adjuntos del evento no se pueden subir, por favor inténtalo de nuevo más tarde.",
  "Community": "Comunidad",
  "Non-registered user": "Usuario no registrado",
  "Type user name, e-mail or community you want to invite": "Escribe el nombre de usuario, correo electrónico o comunidad que quieres invitar",
  "Type user name or e-mail you want to invite. You can invite up to {{count}} people.": "Escribe el nombre de usuario o correo electrónico que quieres invitar. Puedes invitar hasta {{count}} personas.",
  "You've reached the {{count}}-invitation limit for your role. Remove someone to add another.": "Has alcanzado el límite de {{count}} invitaciones para tu rol. Elimina a alguien para invitar a otro.",
  "Invalid option": "Opción inválida",
  "Custom channels": "Canales personalizados",
  "Default channels": "Canales por defecto",
  "Tags appear for organizations that are using custom channels": "Las etiquetas aparecen para organizaciones que utilizan canales personalizados",
  "Copy link for attendee": "Copiar enlace para <strong>asistente</strong>",
  "Copy link for presenter": "Copiar enlace para <strong>presentador</strong>",
  "QR code for attendee": "Código QR para <strong>asistente</strong>",
  "QR code for presenter": "Código QR para <strong>presentador</strong>",
  "Invite more": "Invitar más",
  "Cancel event": "Cancelar evento",
  "Event canceled successfully": "Evento cancelado correctamente",
  "Something went wrong. The event couldn’t be canceled.": "Algo salió mal. El evento no se pudo cancelar.",
  "Are you sure you want to cancel {{name}}?": "¿Estás seguro de que quieres cancelar {{name}}?",
  "Event type is not supported for editing": "El tipo de evento no es compatible con la edición",
  "Something went wrong. Event can't be edited right now. Try again later.": "Algo salió mal. El evento no se puede editar en este momento. Inténtalo de nuevo más tarde.",
  "Unable to generate invitation QR code.": "No se pudo generar el código QR de invitación.",
  "Unable to generate invitation token.": "No se pudo generar el token de invitación.",
  "Invite attendee via QR code": "Invitar asistente mediante código QR",
  "Invite presenter via QR code": "Invitar presentador mediante código QR",
  "Reminder created successfully.": "Recordatorio creado correctamente.",
  "Failed to create reminder.": "No se pudo crear el recordatorio.",
  "Up to 64 participants total. Interactive mode: all can share camera and audio": "Hasta 64 participantes totales. Modo interactivo: todos pueden compartir cámara y audio",
  "Up to 64 admins/presenters with 1000 participants total. Presentation mode: Attendees can view, hear, chat, etc.": "Hasta 64 administradores/presentadores con 1000 participantes totales. Modo presentación: Los asistentes pueden ver, escuchar, chatear, etc.",
  "Can view webinar and interact via chat, Q&A, polls, and handouts. Audio/video sharing only if enabled by admin.": "Puede ver el webinar y interactuar a través del chat, preguntas y respuestas, encuestas y materiales. El compartido de audio/vídeo solo está habilitado si lo permite el administrador.",
  "Full control over webinar. Can manage all settings, record, end webinar, control attendee permissions, and share content.": "Control total sobre el webinar. Puede gestionar todas las configuraciones, grabar, finalizar el webinar, controlar los permisos de los asistentes y compartir contenido.",
  "Can share content (mic, webcam, files, screen) but cannot access host controls or manage other participants.": "Puede compartir contenido (micrófono, cámara, archivos, pantalla) pero no puede acceder a los controles del anfitrión o gestionar otros participantes.",
  "Reminder name": "Nombre del recordatorio",
  "Reminder details": "Detalles del recordatorio",
  "Date and time": "Fecha y hora",
  "Type user name or community you want to remind. You can remind up to {{count}} people.": "Escribe el nombre de usuario o comunidad que quieres recordar. Puedes recordar hasta {{count}} personas.",
  "Type user name you want to remind. You can remind up to {{count}} people.": "Escribe el nombre de usuario que quieres recordar. Puedes recordar hasta {{count}} personas.",
  "Set reminder": "Establecer recordatorio",
  "Add people": "Añadir personas",
  "People ({{invited}}/{{limit}})": "Personas ({{invited}}/{{limit}})",
  "Can not add {{communityName}} community ({{membersCount}} members). Only {{remainingSpots}} of {{limit}} spots left.": "No se puede añadir la comunidad \"{{communityName}}\" ({{membersCount}} miembros). Solo quedan {{remainingSpots}} de {{limit}} plazas.",
  "You reached the limit of {{limit}} people. Remove some people, if you want to add new ones.": "Has alcanzado el límite de {{limit}} personas. Elimina a algunas personas si quieres añadir otras nuevas.",
  "Edit reminder": "Editar recordatorio",
  "Reminder edited successfully.": "Recordatorio editado correctamente.",
  "Delete reminder": "Eliminar recordatorio",
  "Reminder deleted successfully.": "Recordatorio eliminado correctamente.",
  "Are you sure you want to delete {{name}} reminder?": "¿Estás seguro de que quieres eliminar el recordatorio de {{name}}?",
  "Duplicate Reminder": "Duplicar recordatorio",
  "Reminder duplicated successfully.": "Recordatorio duplicado correctamente.",
  "Duplicate this reminder with everyone added?": "¿Duplicar este recordatorio con todos los miembros añadidos?",
  "Everyone currently added will get the duplicated reminder.": "Todos los miembros añadidos recibirán el recordatorio duplicado.",
  "The duplicated reminder won't include any people.": "El recordatorio duplicado no incluirá a ninguna persona.",
  "Something went wrong. The reminder couldn’t be deleted.": "Algo salió mal. El recordatorio no se pudo eliminar.",
  "People ({{count}})": "Personas ({{count}})",
  "Add people ({{invited}}/{{limit}})": "Añadir personas ({{invited}}/{{limit}})",
  "All people": "Todas las personas",
  "Add more people": "Añadir más personas",
  "Remove from reminder": "Eliminar del recordatorio",
  "Something went wrong. {{name}} couldn’t be removed from reminder": "Algo salió mal. No se pudo eliminar a {{name}} del recordatorio",
  "{{name}} removed from reminder successfully": "{{name}} eliminado del recordatorio correctamente",
  "You can add the user again at any time.": "Puedes volver a añadir al usuario en cualquier momento.",
  "Are you sure you want to remove {{name}} from this reminder?": "¿Estás seguro de que quieres eliminar a {{name}} de este recordatorio?",
  "Reminder has been reported to admins of your organization.": "El recordatorio ha sido informado a los administradores de tu organización.",
  "Something went wrong. Please try again later.": "Algo salió mal. Por favor, inténtalo de nuevo más tarde.",
  "Error": "Error",
  "Welcome to BigHeart's AI Knowledge Assistant! I can help you find information from internal documents — including policies, processes, team guides, and more. Ask me anything and I'll do my best to find the right answer for you.": "Bienvenido a la Asistente de Conocimiento de BigHeart. Puedo ayudarte a encontrar información de nuestros documentos internos, incluyendo políticas, procesos, guías de equipos y más. Hazme cualquier pregunta y haré lo mejor para encontrar la respuesta correcta para ti.",
  "Info: Always verify answers — AI responses may not be fully accurate": "Info: Siempre verifica las respuestas — las respuestas de IA pueden no ser completamente precisas",
  "Write a message": "Escribir un mensaje",
  "AI Chat": "Chat de IA",
  "AI Knowledge Assistant": "Asistente de Conocimiento de IA",
  "{{count}} people": "{{count}} personas",
  "Until {{ date, time }}": "Hasta las {{ date, time }}",
  "private": "privado",
  "public": "público",
  "secret": "secreto",
  "Chat info": "Información del chat",
  "Delete chat": "Eliminar chat",
  "Are you sure you want to delete this chat?": "¿Estás seguro de que quieres eliminar este chat?",
  "Chat deleted successfully": "Chat eliminado correctamente",
  "Something went wrong. Chat couldn't be deleted.": "Algo salió mal. No se pudo eliminar el chat.",
  "Something went wrong. Chat couldn't be created.": "Algo salió mal. No se pudo crear el chat.",
  "Something went wrong. Message couldn't be sent.": "Algo salió mal. No se pudo enviar el mensaje.",
  "Chat created successfully": "Chat creado correctamente",
  "Redirected to existing chat": "Redirigido al chat existente",
  "Go to profile": "Ir al perfil",
  "Admin Console": "Consola de administración",
  "No messages yet": "No hay mensajes aún",
  "No group messages": "No hay mensajes de grupo",
  "No unread messages": "No hay mensajes no leídos",
  "Create a message to start a new conversation": "Crea un mensaje para iniciar una nueva conversación",
  "Try refining your search terms or start a new conversation": "Prueba a refinar los términos de búsqueda o inicia una nueva conversación",
  "Your group messages will appear here": "Tus mensajes de grupo aparecerán aquí",
  "Your unread messages will appear here": "Tus mensajes no leídos aparecerán aquí",
  "Create a message": "Crear un mensaje",
  "You": "Tú",
  "Send a message ...": "Enviar un mensaje ...",
  "{{fileName}} exceeds the {{fileSize}} MB limit. Nothing was added.": "{{fileName}} supera el límite de {{fileSize}} MB. No se añadió nada.",
  "{{count}} files exceed the {{fileSize}} MB limit. Nothing was added.": "{{count}} archivos superan el límite de {{fileSize}} MB. No se añadió nada.",
  "Maximum {{count}} attachments per message. Nothing was added.": "Máximo {{count}} archivos adjuntos por mensaje. No se añadió nada.",
  "Nothing was added: max {{count}} attachments, max {{fileSize}} MB per file.": "No se añadió nada: máximo {{count}} archivos adjuntos, máximo {{fileSize}} MB por archivo.",
  "To:": "Para:",
  "Add members": "Añadir miembros",
  "Chat name": "Nombre del chat",
  "Rename chat": "Renombrar chat",
  "Reset to default": "Restablecer predeterminado",
  "Leave empty to name the chat after its participants": "Déjalo vacío para nombrar el chat según sus participantes",
  "Chat renamed successfully": "Chat renombrado correctamente",
  "Something went wrong. Chat couldn't be renamed.": "Algo salió mal. No se pudo renombrar el chat.",
  "Remove member": "Eliminar miembro",
  "Are you sure you want to remove <strong>{{memberName}}</strong> from this chat?": "¿Estás seguro de que quieres eliminar a <strong>{{memberName}}</strong> de este chat?",
  "Member removed successfully": "Miembro eliminado correctamente",
  "Something went wrong. Member couldn't be removed.": "Algo salió mal. No se pudo eliminar al miembro.",
  "Member(s) added successfully": "Miembro(s) añadido(s) correctamente",
  "Something went wrong. Member(s) couldn't be added.": "Algo salió mal. No se pudieron añadir los miembros.",
  "Search members": "Buscar miembros",
  "You must select at least 1 member to add.": "Debes seleccionar al menos 1 miembro para añadir.",
  "Selected": "Seleccionados",
  "Add": "Añadir",
  "Show search": "Mostrar búsqueda",
  "Hide search": "Ocultar búsqueda",
  "There are no messages yet. Send a message to start a conversation.": "Aún no hay mensajes. Envía un mensaje para iniciar una conversación.",
  "chatNewIncomingMessages_one": "{{count}} mensaje nuevo",
  "chatNewIncomingMessages_other": "{{count}} mensajes nuevos",
  "Cannot generate link with login token": "No se puede generar el enlace con el token de inicio de sesión",
  "photo_one": "Foto",
  "photo_other": "{{count}} fotos",
  "video_one": "Vídeo",
  "video_other": "{{count}} vídeos",
  "file_one": "Archivo",
  "file_other": "{{count}} archivos",
  "Multiple attachments": "Adjuntos múltiples",
  "Visibility": "Visibilidad",
  "You can choose multiple options": "Puedes elegir múltiples opciones",
  "Date of birth is not valid": "La fecha de nacimiento no es válida",
  "Email me a login link": "Envíame un enlace de inicio de sesión",
  "Error: Description is required": "Error: La descripción es obligatoria",
  "Number of days in month is not valid": "El número de días del mes no es válido"
}
